const translations = {
  '欢迎回来': 'Welcome back',
  '开发者注册': 'Developer onboarding',
  '登录 DeRAS': 'Sign in to DeRAS',
  '创建账户': 'Create your account',
  '登录': 'Sign In',
  '注册': 'Register',
  '首页': 'Home',
  '主要导航': 'Primary Navigation',
  '开放接口': 'Open API',
  '任务大屏': 'Task Dashboard',
  '登录 / 注册': 'Sign In / Register',
  '邮箱或国际手机号': 'Email or international phone',
  '邮箱或带国际区号的手机号': 'Email or phone with country code',
  '密码': 'Password',
  '请输入密码': 'Enter your password',
  '显示密码': 'Show password',
  '隐藏密码': 'Hide password',
  '正在登录...': 'Signing in...',
  '登录成功。': 'Signed in successfully.',
  '请填写标记出的登录信息。': 'Please complete the highlighted sign-in fields.',
  '返回首页': 'Back to Home',
  '发布任务': 'Publish Task',
  '任务发布': 'Task Publishing',
  '任务市场': 'Task Market',
  '机器人市场': 'Robot Market',
  '进行中任务': 'Active Tasks',
  '个人中心': 'Profile',
  '我的机器人': 'My Robots',
  '查看我已注册机器人': 'View My Registered Robots',
  '已发布任务': 'Published Tasks',
  '发布新任务': 'Publish New Task',
  '刷新': 'Refresh',
  '全部发布': 'All Published',
  '可接单': 'Open',
  '待审核': 'Pending Review',
  '已接单': 'Accepted',
  '已通过': 'Approved',
  '查看详情': 'View Details',
  '接单前查看': 'Review Before Accepting',
  '查看时间线': 'View Timeline',
  '关闭': 'Close',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '重置': 'Reset',
  '上一步': 'Previous',
  '下一步': 'Next',
  '已选择': 'Selected',
  '未选择': 'Not Selected',
  '未填写': 'Not Provided',
  '未知': 'Unknown',
  '服务类型': 'Service Type',
  '机器人类型': 'Robot Type',
  '任务标题': 'Task Title',
  '服务位置': 'Service Location',
  '预约时间': 'Schedule Time',
  '联系电话': 'Contact Phone',
  '任务描述': 'Task Details',
  '平台补助': 'Platform Subsidy',
  '任务摘要': 'Task Summary',
  '任务向导': 'Task Guide',
  '步骤': 'Step',
  '新任务': 'New mission',
  '编辑任务': 'Editing mission',
  '按步骤发布任务': 'Publish Task Step by Step',
  '按步骤编辑任务': 'Edit Task Step by Step',
  '选择服务类型': 'Choose service type',
  '选择机器人类型': 'Choose robot type',
  '选择起点和终点': 'Choose start and end points',
  '选择预约时间': 'Choose schedule time',
  '填写联系电话': 'Enter contact phone',
  '补充任务详情': 'Add task details',
  '是否允许任务分包': 'Task subcontracting',
  '平台 RoboCoin 补助': 'Platform RoboCoin subsidy',
  '确认任务详情': 'Review task details',
  '服务': 'Service',
  '机器人': 'Robot',
  '标题': 'Title',
  '位置': 'Location',
  '时间': 'Time',
  '电话': 'Phone',
  '详情': 'Details',
  '分包': 'Split',
  '补助': 'Subsidy',
  '确认': 'Review',
  '照片': 'Photo',
  '上门服务': 'On-site Service',
  '接驳出行': 'Shuttle Service',
  '到点': 'On-site',
  '路线': 'Route',
  '机器人到一个固定地点完成服务。': 'The robot completes service at a fixed location.',
  '机器人从起点到终点执行接驳。': 'The robot provides transport from the start to the destination.',
  '清洁机器人': 'Cleaning Robot',
  '配送机器人': 'Delivery Robot',
  '接驳机器人': 'Shuttle Robot',
  '巡检机器人': 'Inspection Robot',
  '无人机': 'Drone',
  '选择': 'Choose',
  '搜索': 'Search',
  '搜索中...': 'Searching...',
  '选择起点': 'Choose Start Point',
  '选择终点': 'Choose Destination',
  '选择服务地址': 'Choose Service Address',
  '请在地图上选择起点': 'Choose a start point on the map',
  '请在地图上选择终点': 'Choose a destination on the map',
  '请在地图上选择服务地址': 'Choose a service address on the map',
  '起点': 'Start',
  '终点': 'Destination',
  '服务地址': 'Service Address',
  '任务详情': 'Task Detail',
  '任务分包属性': 'Subcontracting',
  '目标地址': 'Target Address',
  '服务方预计收入': 'Estimated Provider Income',
  '平台手续费': 'Platform Fee',
  '手续费规则': 'Fee Rule',
  'DeRAS派单进度': 'DeRAS Dispatch Progress',
  '审核状态': 'Review Status',
  '审核说明': 'Review Note',
  '推荐原因': 'Recommendation',
  '候选队列': 'Candidate Queue',
  '派单兜底': 'Dispatch Fallback',
  '发布者派单时间线': 'Publisher Dispatch Timeline',
  '刷新时间线': 'Refresh Timeline',
  '暂无派单时间线': 'No dispatch timeline',
  '确认接单': 'Confirm Acceptance',
  '先不接': 'Not Now',
  '获取当前位置并计算距离': 'Use Current Location and Calculate Distance',
  '当前位置到任务起点/服务点距离': 'Distance to Task Location',
  '允许定位后可核对接单距离': 'Allow Location Access to Check Distance',
  '点击获取位置时，浏览器会询问是否允许 RoboCoin 使用你的位置。': 'Your browser will ask whether RoboCoin may use your location.',
  '定位权限尚未开启': 'Location Access Is Off',
  '请在浏览器地址栏的网站权限中允许访问位置，然后重新获取。': 'Allow location access in the site permissions menu, then retry.',
  '开启并获取位置': 'Allow and Locate',
  '重新尝试': 'Retry',
  '定位中...': 'Locating...',
  '尚未计算': 'Not Calculated',
  '任务消息': 'Task Messages',
  '消息': 'Messages',
  '待处理': 'Action Required',
  '流程': 'Progress',
  '结算/取消': 'Settlement / Cancellation',
  '全部': 'All',
  '全部已读': 'Mark All Read',
  '清空全部消息': 'Clear All Messages',
  '标记已读': 'Mark Read',
  '删除': 'Delete',
  '去处理': 'Open',
  '未读': 'Unread',
  '通知': 'Notice',
  '暂无消息': 'No Messages',
  '消息已全部读完': 'All messages have been read',
  '机器人照片': 'Robot Photo',
  '上传一张机器人照片': 'Upload a Robot Photo',
  '点击更换照片': 'Click to Replace Photo',
  '机器人名称': 'Robot Name',
  '机器人类别': 'Robot Category',
  '服务区域': 'Service Region',
  '联系方式': 'Contact',
  '收款钱包': 'Payment Wallet',
  '注册机器人': 'Register Robot',
  '注册摘要': 'Registration Summary',
  '机器人注册': 'Robot Registration',
  '按步骤注册机器人': 'Register a Robot Step by Step',
  '所有类别同时展示，可直接比较和切换。': 'All categories are shown for direct comparison and switching.',
  '用于后续任务匹配和机器人市场展示。': 'Used for task matching and robot marketplace listings.',
  '例如：PIX 园区清扫 01': 'Example: PIX Campus Cleaning 01',
  '服务区域（可选）': 'Service Region (Optional)',
  '例如：中国 / 贵州 / 贵阳；留空表示不限制服务区域': 'Example: China / Guizhou / Guiyang; leave blank for no service region restriction',
  '例如：中国 / 贵州 / 贵阳；留空表示不限制': 'Example: China / Guizhou / Guiyang; leave blank for no restriction',
  '不限制服务区域': 'No Service Region Restriction',
  '请输入手机号或其他联系方式': 'Enter a phone number or other contact information',
  '当前状态': 'Current Status',
  '待验证通过': 'Pending Verification',
  '机器人收款钱包地址（可选）': 'Robot Payment Wallet Address (Optional)',
  '能力简要描述（可选）': 'Capability Summary (Optional)',
  '可选，简要描述机器人能力、适用场景或优势': 'Optional: briefly describe the robot capabilities, use cases, or advantages',
  '可暂时留空。机器人准备开启接单时，平台会要求补充有效的钱包地址。': 'You can leave this blank for now. A valid wallet address is required before the robot accepts tasks.',
  '打开 MetaMask，复制 0x 开头的钱包地址后粘贴到这里。': 'Open MetaMask, copy the wallet address beginning with 0x, and paste it here.',
  '打开 TokenPocket，进入收款页复制钱包地址。后续 RoboCoin 收益会发到这个地址。': 'Open TokenPocket and copy the wallet address from the receive page. Future RoboCoin earnings will be sent to this address.',
  '请最后确认机器人资料': 'Review the Robot Profile',
  '有信息不对，直接展开对应清单项修改；确认无误后提交注册。': 'Expand any checklist item that needs changes. Submit the registration after confirming all information.',
  '已完成': 'Complete',
  '收起': 'Collapse',
  '完成修改': 'Finish Editing',
  '回到这一步': 'Return to This Step',
  '确认注册': 'Confirm Registration',
  '我已注册的机器人': 'My Registered Robots',
  '刷新列表': 'Refresh List',
  '联系方式：': 'Contact:',
  '收款钱包：': 'Payment Wallet:',
  '接单中': 'Accepting Tasks',
  '暂停接单': 'Task Acceptance Paused',
  'DeRAS可向该机器人发送派单邀请': 'DeRAS can send dispatch invitations to this robot',
  '不会收到新的自动派单邀请': 'New automatic dispatch invitations will not be received',
  '暂停': 'Pause',
  '开启': 'Enable',
  'SDK Agent 在线': 'SDK Agent Online',
  'SDK Agent 离线': 'SDK Agent Offline',
  '设备上线检测': 'Device Online Check',
  '未填写能力简要描述。': 'No capability summary provided.',
  'SDK已上报，请确认这是不是你的设备。': 'The SDK has reported a device. Confirm whether it belongs to you.',
  'SDK绑定令牌：': 'SDK Binding Token:',
  '绑定令牌已复制': 'Binding token copied',
  '复制令牌': 'Copy Token',
  '查看机器人档案': 'View Robot Profile',
  '更新收款钱包': 'Update Payment Wallet',
  '填写收款钱包': 'Add Payment Wallet',
  '查看 SDK 安装步骤': 'View SDK Installation Steps',
  '取消注册': 'Cancel Registration',
  '暂无已注册机器人，先提交第一台机器人资料吧。': 'No registered robots yet. Submit the profile for your first robot.',
  '在机器人工控机终端执行安装命令，页面会自动识别设备状态。': 'Run the installation command in the robot controller terminal. The page will detect the device status automatically.',
  '当前机器人': 'Current Robot',
  '绑定令牌：': 'Binding Token:',
  '有效期：': 'Expires:',
  '已失效或已绑定': 'Expired or Already Bound',
  '页面还没收到完整在线结果': 'The Complete Online Status Has Not Arrived Yet',
  '你只需要完成安装，设备认证由 SDK 自动处理': 'Complete the Installation; the SDK Handles Device Authentication',
  'SDK 会在工控机本地读取芯片身份并发起安全签名，私钥不会离开芯片。绑定成功后，同一个机器人 ID 再换其他工控机上报会被平台拦截。': 'The SDK reads the chip identity and signs locally on the controller. The private key never leaves the chip. After binding, reports for the same robot ID from another controller will be blocked.',
  '在工控机终端执行这一条命令，自动安装、绑定并启动后台服务': 'Run this command in the controller terminal to install, bind, and start the background service',
  '一键安装命令已复制': 'Installation command copied',
  '复制一键安装命令': 'Copy Installation Command',
  '故障排查：正常注册不需要执行，只有页面一直离线时由管理员指导使用': 'Troubleshooting: only use this with administrator guidance if the device remains offline',
  'SDK排查命令已复制': 'SDK diagnostic command copied',
  '复制排查命令': 'Copy Diagnostic Command',
  '看到什么算完成？': 'How Do I Know It Is Complete?',
  '页面会自动刷新设备状态。如果看到“SDK已上报”，请确认这是不是你的设备，确认后机器人正式通过。': 'The page refreshes the device status automatically. When "SDK Report Received" appears, confirm the device to complete robot verification.',
  '一键命令绑定成功后会创建 roc-robot-agent 后台服务，并每 30 秒向 DeRAS 上报一次 TPM 签名心跳。后续服务者点击出发、申请开始或申请结束时，SDK 会自动向 DeRAS 上报。': 'After binding, the command creates the roc-robot-agent service and sends a TPM-signed heartbeat to DeRAS every 30 seconds. The SDK also reports departure, start, and completion actions automatically.',
  '安装命令最后会自动完成一次诊断，正常情况下用户不需要再执行其他命令。工控机重启后服务会自动恢复。': 'The installation command runs a final diagnostic automatically. No other commands are normally required, and the service restarts with the controller.',
  '如果超过10分钟、网络断开或工控机关机，请点击“重新生成绑定令牌”，再复制新的一键安装命令。': 'If more than 10 minutes have passed, the network disconnected, or the controller shut down, regenerate the binding token and copy the new installation command.',
  'SDK 已经读取到设备': 'The SDK Has Detected the Device',
  '请确认这台设备确实属于当前机器人。确认后，平台会把这个 TPM 公钥作为后续 DeRAS 派单验签依据。': 'Confirm that this device belongs to the current robot. Its TPM public key will then be used to verify future DeRAS dispatches.',
  '确认这是我的设备': 'Confirm This Is My Device',
  '收起详情': 'Hide Details',
  '重新生成令牌': 'Regenerate Token',
  '我知道了': 'Got It',
  '打开机器人上的工控机终端': 'Open the Robot Controller Terminal',
  '不需要先在 Windows 下载，也不需要手动上传 zip。直接 SSH 登录工控机，在工控机终端里执行页面给出的命令。': 'No Windows download or manual ZIP upload is required. SSH directly into the controller and run the command shown on this page.',
  '复制专属绑定令牌命令': 'Copy the Dedicated Binding Command',
  '每台机器人注册后都会生成一次性绑定令牌，命令会带上这个令牌，平台就知道这次上报属于哪一个机器人。': 'Each robot receives a one-time binding token. The command includes it so the platform can associate the report with the correct robot.',
  'SDK 自动拉取并绑定 TPM': 'The SDK Downloads and Binds the TPM Automatically',
  '命令会从 GitHub 拉取 SDK，检查 TPM 工具，读取 TPM 公钥，让 TPM 私钥签名后上报平台数据库。': 'The command downloads the SDK from GitHub, checks the TPM tools, reads the TPM public key, signs with the TPM private key, and reports to the platform.',
  '自动启动后台服务': 'Start the Background Service Automatically',
  '绑定成功后 SDK 会创建 roc-robot-agent 服务，开机自启，每30秒发送一次TPM签名心跳；后续订单出发、开始和结束验证都由它自动签名上报。': 'After binding, the SDK creates the roc-robot-agent service, starts it on boot, and sends a TPM-signed heartbeat every 30 seconds. It also signs and reports subsequent order events automatically.',
  '轮式机器人': 'Wheeled Robot',
  '机器狗 Go2': 'Robot Dog Go2',
  '适合移动底盘、园区巡航、通用移动平台。': 'For mobile bases, campus patrol, and general-purpose mobile platforms.',
  '适合扫地、保洁、地面清扫等场景。': 'For sweeping, housekeeping, and floor cleaning.',
  '适合空中巡航、拍摄、轻量配送。': 'For aerial patrol, imaging, and light delivery.',
  '适合人员或货物短途接驳。': 'For short-distance passenger or cargo shuttle service.',
  '适合巡逻、检查、异常发现。': 'For patrol, inspection, and anomaly detection.',
  '适合跳舞、转身、短距离移动等演示任务。': 'For demonstrations such as dancing, turning, and short-distance movement.',
  '请输入机器人名称': 'Enter a robot name',
  '请选择机器人类别': 'Choose a robot category',
  '请上传机器人照片': 'Upload a robot photo',
  '请输入联系方式': 'Enter contact information',
  '能力描述': 'Capability Description',
  '未填写，提交时会保存为空': 'Not provided; this field will be saved empty',
  '待生成': 'Pending Generation',
  '等待心跳上报': 'Waiting for Heartbeat',
  '设备确认后开始检测': 'Detection Starts After Device Confirmation',
  '设备状态刷新失败': 'Failed to Refresh Device Status',
  '设备状态刷新失败，请确认后端服务是否在线': 'Failed to refresh device status. Check whether the backend service is online.',
  '接单状态更新失败': 'Failed to Update Task Acceptance Status',
  '已开启接单，DeRAS可以派单': 'Task acceptance enabled. DeRAS can now dispatch tasks.',
  '已暂停接单': 'Task acceptance paused',
  '接单状态更新失败，请检查后端服务': 'Failed to update task acceptance status. Check the backend service.',
  '已收到 TPM 公钥，请确认这是不是你的设备': 'TPM Public Key Received; Confirm This Is Your Device',
  '设备已确认，正在等待 SDK Agent 心跳': 'Device confirmed; waiting for the SDK Agent heartbeat',
  'SDK Agent 已在线，后续验签会自动上报': 'SDK Agent is online; future signature verification will be reported automatically',
  '最近一次心跳验签异常，请联系管理员排查': 'The latest heartbeat signature verification failed. Contact an administrator.',
  '内容已复制': 'Content Copied',
  '复制失败，请手动复制': 'Copy failed. Copy the content manually.',
  '钱包地址格式不正确，应为 0x 开头且后接 40 位十六进制字符': 'Invalid wallet address. It must begin with 0x followed by 40 hexadecimal characters.',
  '收款钱包格式不正确，应为 0x 开头的 42 位地址': 'Invalid payment wallet. Enter a 42-character address beginning with 0x.',
  '请先完成当前步骤的必填内容': 'Complete the required fields in this step first',
  '最近心跳验签失败': 'Latest Heartbeat Signature Verification Failed',
  '等待机器人资料': 'Waiting for Robot Profile',
  '设备在线，心跳正常': 'Device Online; Heartbeat Normal',
  '最近心跳验签异常': 'Latest Heartbeat Signature Verification Failed',
  '设备已确认，等待 Agent 心跳': 'Device Confirmed; Waiting for Agent Heartbeat',
  '已收到 TPM 公钥，等待确认': 'TPM Public Key Received; Waiting for Confirmation',
  '等待 SDK 安装': 'Waiting for SDK Installation',
  'SDK 已在工控机完成首次上报。': 'The SDK has completed its first report from the controller.',
  '在工控机终端执行一行安装命令。': 'Run the one-line installation command in the controller terminal.',
  '已收到 TPM 公钥': 'TPM Public Key Received',
  '平台还没有收到 TPM 公钥和签名报告。': 'The platform has not received a TPM public key or signature report yet.',
  '等待用户确认设备': 'Waiting for Device Confirmation',
  '用户已确认该 TPM 设备属于当前机器人。': 'The user confirmed that this TPM device belongs to the current robot.',
  '请确认这是不是你的设备。': 'Confirm whether this device belongs to you.',
  '收到 TPM 公钥后再确认设备。': 'Confirm the device after its TPM public key is received.',
  '2分钟内收到 TPM 签名心跳。': 'A TPM-signed heartbeat was received within 2 minutes.',
  '等待 Agent 心跳上报。': 'Waiting for the Agent heartbeat.',
  '确认设备后开始检测 Agent。': 'Agent detection starts after device confirmation.',
  '最近心跳时间': 'Latest Heartbeat',
  '暂无心跳记录。': 'No heartbeat records.',
  '待上报': 'Pending Report',
  '这一项还没填写完整': 'This item is incomplete',
  '只能上传图片文件': 'Only image files can be uploaded',
  '图片大小不能超过 8 MB': 'The image must not exceed 8 MB',
  '图片上传请求失败，请确认后端服务已启动。': 'Image upload failed. Check whether the backend service is running.',
  '图片上传失败': 'Image Upload Failed',
  '当前未识别到登录用户': 'No signed-in user was detected',
  '请先完成当前步骤': 'Complete the current step first',
  '清单里还有信息未完成，请点击修改补齐': 'Some checklist items are incomplete. Open them to add the missing information.',
  '正在注册机器人': 'Registering Robot',
  '正在提交机器人资料并进入待验证流程，请稍候。': 'Submitting the robot profile for verification. Please wait.',
  '机器人注册失败': 'Robot Registration Failed',
  '机器人注册成功': 'Robot Registration Successful',
  '资料已保存，当前状态为待验证通过。': 'The profile has been saved and is pending verification.',
  '机器人注册失败，请检查后端服务': 'Robot registration failed. Check the backend service.',
  '机器人列表加载失败': 'Failed to Load Robot List',
  '绑定令牌生成失败': 'Failed to Generate Binding Token',
  'SDK绑定令牌已重新生成，请在10分钟内运行安装命令。': 'The SDK binding token was regenerated. Run the installation command within 10 minutes.',
  '绑定令牌已重新生成，安装命令已更新': 'The binding token was regenerated and the installation command was updated',
  '绑定令牌生成失败，请检查后端服务': 'Failed to generate a binding token. Check the backend service.',
  '暂未拿到SDK上报reportId，请先刷新列表或重新运行SDK': 'No SDK report ID is available yet. Refresh the list or run the SDK again.',
  '确认SDK设备': 'Confirm SDK Device',
  '确认是我的设备': 'Confirm My Device',
  '再检查一下': 'Check Again',
  '设备确认失败': 'Device Confirmation Failed',
  '设备已确认，机器人注册完成': 'Device confirmed. Robot registration is complete.',
  '取消注册失败': 'Failed to Cancel Registration',
  '已取消注册': 'Registration Cancelled',
  '取消注册失败，请稍后重试': 'Failed to cancel registration. Try again later.',
  'ROBOCOIN 账户中心': 'ROBOCOIN ACCOUNT CENTER',
  '订单记录': 'ORDER HISTORY',
  '任务发布记录': 'PUBLISHED TASKS',
  '复核与仲裁': 'REVIEW & ARBITRATION',
  '重新发布中': 'Republishing',
  '重新发布任务': 'Republish task',
  '重新发布': 'Republish',
  '保持取消': 'Keep cancelled',
  '删除任务': 'Delete task',
  '永久删除': 'Delete permanently',
  '保留任务': 'Keep task',
  '名称': 'Name',
  '类别': 'Category',
  '区域': 'Region',
  '能力': 'Capability',
  '添加机器人照片': 'Add a robot photo',
  '上传一张清晰图片，用于个人资料和机器人市场展示。': 'Upload one clear image for the profile and robot market.',
  '暂未填写，接单前补充': 'Not provided; required before accepting tasks',
  '未上传': 'Not Uploaded',
  '已上传照片': 'Photo Uploaded',
  '暂无进行中任务': 'No Active Tasks',
  '订单状态': 'Order Status',
  '我的身份': 'My Role',
  '进行中': 'In Progress',
  '已完成': 'Completed',
  '已取消': 'Cancelled',
  '操作': 'Actions',
  '任务ID': 'Task ID',
  '任务': 'Task',
  '地点/时间': 'Location / Time',
  '预算': 'Budget',
  '状态': 'Status',
  '取消发布': 'Cancel Publication',
  '开放抢单': 'Open for Grabbing',
  '任务已接单': 'Task accepted',
  '暂无候选': 'No candidate',
  '等待派单': 'Waiting dispatch',
  '暂无候选，开放抢单': 'No Candidate; Open for Grabbing',
  '候选超时，正在重派': 'Candidate Timed Out; Redispatching',
  '定位权限被拒绝，请允许浏览器访问位置后重试。': 'Location access was denied. Allow location access in your browser and retry.',
  '当前浏览器不支持定位功能。': 'This browser does not support location services.',
  '暂时无法获取当前位置，请检查系统定位或网络环境。': 'Unable to get your location. Check system location settings and network access.',
  '定位超时，请稍后重试。': 'Location request timed out. Please retry.',
  '定位失败，请稍后重试。': 'Unable to get your location. Please retry.',
  '页面处理出现异常，请刷新页面后重试。': 'Something went wrong. Refresh the page and try again.',
  '全球开发者与智能体门户': 'Global Developer & Agent Portal',
  '全球开发者与智能体门户（GLOBAL）': 'GLOBAL DEVELOPER & AGENT PORTAL',
  '构建自主机器经济': 'Build the Autonomous Machine Economy',
  '注册机器智能体、安装 ROBO SDK、派发可验证任务，并将实体机器接入全球 DeRAS 网络。': 'Register machine agents, install the ROBO SDK, dispatch verifiable missions, and connect physical machines to the global DeRAS network.',
  '加入 ROBO 生态': 'Join the ROBO Ecosystem',
  '创建开发者账户': 'Create Developer Account',
  '查看 SDK 文档': 'View SDK Documentation',
  '手机 H5 入口': 'Mobile H5 Access',
  '扫码在手机上继续': 'Scan to continue on your phone',
  '请先使用局域网地址打开本页，再用手机扫码。': 'Open this page with its LAN address before scanning on a phone.',
  '打开 H5': 'Open H5',
  '复制链接': 'Copy link',
  '复制手机 H5 地址': 'Copy mobile H5 URL',
  '返回首页按钮': 'Return to home',
  '账户登录与注册': 'Account access',
  '显示名称': 'Display name',
  '可选，留空时自动生成': 'Optional; generated if left blank',
  '邮箱': 'Email',
  '国家/地区代码': 'Country code',
  '手机号码': 'Phone number',
  '本地手机号码': 'Local phone number',
  '请提供邮箱或手机号码，手机号码需填写国家/地区代码。': 'Provide an email or a phone number. Phone numbers require a country code.',
  '至少 8 个字符': 'At least 8 characters',
  '确认密码': 'Confirm password',
  '请再次输入密码': 'Enter your password again',
  '正在创建账户...': 'Creating account...',
  '任务编排器': 'Mission Composer',
  'DeRAS 移动端': 'DeRAS Mobile',
  '在线': 'LIVE',
  '预览': 'PREVIEW',
  '需要登录授权': 'AUTHORIZATION REQUIRED',
  '现场任务': 'FIELD MISSION',
  '账户已同步': 'ACCOUNT SYNCED',
  '界面预览': 'UI PREVIEW',
  '任务构建': 'MISSION BUILD',
  '任务市场标题': 'TASK MARKET',
  'DeRAS 审核': 'DERAS AUDIT',
  '任务详情标题': 'TASK DETAIL',
  '执行方案': 'FULFILLMENT PLAN',
  '预设路线': 'Preset route',
  '前进 10 米 -> 旋转 360 度 -> 前进 10 米': 'Forward 10 m -> rotate 360 deg -> forward 10 m',
  '移动距离（米）': 'Move distance (m)',
  '转向时长（秒）': 'Turn duration (s)',
  '智能体现场控制台': 'Agent Field Console',
  '网络在线': 'Network Live',
  '离线': 'Offline',
  '移动端入口 / DERAS': 'MOBILE ACCESS / DERAS',
  '连接你的真实世界任务': 'Connect Your Real-World Missions',
  '发布任务、查看机器人在线状态，并在移动端跟进执行进度。': 'Publish tasks, check robot availability, and follow execution from mobile.',
  '登录或注册': 'Sign In or Register',
  '正在建立连接...': 'Connecting...',
  '进入移动工作台': 'Enter Mobile Workspace',
  '你的名称': 'Your name',
  '区号': 'Country code',
  '手机号': 'Phone number',
  '至少 8 位': 'At least 8 characters',
  '再次输入密码': 'Enter password again',
  '正在创建...': 'Creating...',
  '暂时没有可用账户？': 'No account available yet?',
  '仅预览界面': 'Preview Interface',
  'DERAS 任务网络': 'DERAS MISSION NETWORK',
  '现场控制': 'FIELD COMMAND',
  '当前为界面预览，登录后才能发布真实任务。': 'This is a UI preview. Sign in to publish real tasks.',
  '账户与电脑端保持同一套任务和机器人数据。': 'Your tasks and robot data stay synchronized with desktop.',
  '预览模式不会写入平台。登录后，手机发布的任务会同步出现在电脑端。': 'Preview mode does not write to the platform. Mobile tasks sync to desktop after sign-in.',
  '快速操作': 'QUICK COMMAND',
  '任务控制': 'Mission Control',
  '同步中': 'Syncing',
  '实时数据': 'Live Data',
  '地图选点、任务分包、预估与正式提交': 'Map location, subcontracting, estimates, and submission',
  '最近动态': 'Recent Activity',
  '正在同步数据': 'Syncing Data',
  '暂无任务动态': 'No Mission Activity',
  '登录后显示账户中的真实记录。': 'Sign in to view real account activity.',
  '发布首条任务后，状态会显示在这里。': 'Your first published task will appear here.',
  '01 / 服务': '01 / SERVICE',
  '02 / 机器人': '02 / ROBOT',
  '02A / 动作': '02A / ACTION',
  '03 / 标题': '03 / TITLE',
  '04 / 位置': '04 / LOCATION',
  '05 / 时间': '05 / TIME',
  '06 / 联系方式': '06 / CONTACT',
  '07 / 详情': '07 / DETAILS',
  '08 / 协作': '08 / COOPERATION',
  '09 / 确认': '09 / REVIEW',
  '平台预估': 'PLATFORM ESTIMATE',
  '发布机器人任务': 'Publish Robot Mission',
  '地图选点、执行设备、分包属性与任务预估在手机端一次完成。': 'Complete map location, device selection, subcontracting, and estimates on mobile.',
  '当前为界面预览。填写内容不会保存，登录正式账户后才能发布任务。': 'This is a UI preview. Entries are not saved; sign in to publish tasks.',
  '服务方式': 'Service Mode',
  '选择服务方式': 'Choose Service Mode',
  '确定机器人执行定点服务，还是按路线完成接驳。': 'Choose on-site service or route-based shuttle execution.',
  '定点服务': 'On-site Service',
  '机器人到指定位置完成清洁、巡检或配送。': 'The robot performs cleaning, inspection, or delivery at a specified location.',
  '路线接驳': 'Route Shuttle',
  '机器人按确认的起点和终点执行接驳。': 'The robot runs a shuttle between the confirmed start and destination.',
  '预览模式使用默认预估，登录后读取平台实时结果。': 'Preview mode uses a default estimate. Sign in for live platform results.',
  '选择执行设备': 'Choose Execution Device',
  '一次展示全部机器人类型，选中后继续。': 'Compare all robot types and continue after choosing one.',
  '清扫、保洁': 'Cleaning and housekeeping',
  '物品配送、转运': 'Goods delivery and transfer',
  '短途接驳服务': 'Short-distance shuttle service',
  '空中巡航、查看': 'Aerial patrol and observation',
  '巡逻、异常发现': 'Patrol and anomaly detection',
  '动作与短距移动': 'Actions and short-range movement',
  'Go2 动作': 'Go2 Action',
  '配置机器狗动作': 'Configure Go2 Action',
  '动作参数会随任务一起发送给 SDK Agent。': 'Action parameters are sent to the SDK Agent with the mission.',
  '起立': 'Stand Up',
  '切换到稳定站立状态': 'Switch to a stable standing posture',
  '比心': 'Heart Gesture',
  '执行预置比心动作': 'Run the preset heart gesture',
  '巡检演示': 'Patrol Demo',
  '10 米、旋转、再前进 10 米': 'Move 10 m, rotate, then move another 10 m',
  '跳舞 1': 'Dance 1',
  '跳舞 2': 'Dance 2',
  '执行第一套预置舞蹈': 'Run the first preset dance',
  '执行第二套预置舞蹈': 'Run the second preset dance',
  '向前移动': 'Move Forward',
  '向后移动': 'Move Backward',
  '按填写距离向前移动': 'Move forward by the entered distance',
  '按填写距离向后移动': 'Move backward by the entered distance',
  '原地旋转': 'Turn in Place',
  '按填写时长原地旋转': 'Turn in place for the entered duration',
  '停止动作': 'Stop Action',
  '停止当前移动指令': 'Stop the current movement command',
  '描述这次任务': 'Describe This Mission',
  '用一句话让接单方快速理解任务目标。': 'Summarize the mission so providers can understand it quickly.',
  '地图选点': 'Map Location',
  '确认服务位置': 'Confirm Service Location',
  '确认任务路线': 'Confirm Mission Route',
  '通过地图搜索并保存 WGS84 坐标，电脑端会显示同一位置数据。': 'Search the map and save a WGS84 location shared with desktop.',
  '设置开始时间': 'Set Start Time',
  '选择机器人应当开始执行任务的时间。': 'Choose when the robot should start the mission.',
  '填写任务联系人': 'Enter Mission Contact',
  '用于接单与执行过程中的必要确认。': 'Used for required confirmation during acceptance and execution.',
  '任务说明': 'Mission Notes',
  '补充执行要求': 'Add Execution Requirements',
  '写明现场限制、注意事项和交付标准。': 'Describe site limits, precautions, and delivery requirements.',
  '分包属性': 'Subcontracting',
  '允许分包时，接单方必须在接单阶段确定第二段机器人。': 'When subcontracting is allowed, the second robot must be selected during acceptance.',
  '确认发布': 'Review and Publish',
  '确认任务清单': 'Review Mission Checklist',
  '提交前检查任务信息和平台预估。': 'Review mission details and the platform estimate before submission.',
  '平台按任务信息计算补助额度。': 'The platform calculates the subsidy from mission details.',
  '暂无历史数据时按平台默认服务时长预估。': 'The platform uses its default duration when no history is available.',
  '正在读取平台预估...': 'Loading Platform Estimate...',
  '时长待计算': 'Duration Pending',
  '预约开始时间': 'Scheduled Start Time',
  '服务地址': 'Service Address',
  '整单履约': 'Single-Robot Fulfillment',
  '允许两段协作': 'Allow Two-Stage Collaboration',
  '禁止分包，由同一个机器人完成全部任务。': 'Subcontracting is disabled; one robot completes the entire mission.',
  '接单时必须确定第二段机器人和交接方案，不允许执行途中临时转包。': 'The second robot and handoff plan must be set during acceptance.',
  '正式发布任务': 'Publish Mission',
  '正在发布...': 'Publishing...',
  '任务已发布到平台': 'Mission Published',
  '电脑端会读取到同一条任务，后续按现有审核、派单和接单规则流转。': 'The same mission appears on desktop and follows existing review and dispatch rules.',
  '返回工作台': 'Back to Workspace',
  '继续发布': 'Publish Another',
  '修改': 'Edit',
  '请输入 7 至 15 位有效电话号码，可包含国际区号。': 'Enter a valid 7-15 digit phone number; an international prefix is allowed.',
  '预约时间必须晚于当前时间。': 'Schedule time must be in the future.',
  '预约时间格式不正确。': 'Schedule time is invalid.',
  '扫': 'CLN',
  '配': 'DLV',
  '驳': 'SHT',
  '飞': 'AIR',
  '巡': 'INSP',
  '请选择服务方式。': 'Choose a service mode.',
  '请选择机器人类型。': 'Choose a robot type.',
  '请选择 Go2 动作。': 'Choose a Go2 action.',
  '请填写有效的移动距离。': 'Enter a valid movement distance.',
  '请填写任务标题。': 'Enter a mission title.',
  '请在地图上确认服务地址。': 'Confirm the service address on the map.',
  '请在地图上确认起点和终点。': 'Confirm the start and destination on the map.',
  '请选择预约时间。': 'Choose a schedule time.',
  '请填写联系方式。': 'Enter contact information.',
  '请填写任务说明。': 'Enter mission notes.'
  , '派单邀请': 'Dispatch Invitations'
  , '复制 API Token': 'Copy API Token'
  , '复制 Token': 'Copy Token'
  , '退出登录': 'Sign Out'
  , 'RoboCoin 任务发布': 'RoboCoin Task Publishing'
  , '横向浏览并比较，选择后仍可切换。': 'Browse and compare options. You can change your selection later.'
  , '向左浏览机器人类型': 'Browse robot types to the left'
  , '上一组': 'Previous Group'
  , '向右浏览机器人类型': 'Browse robot types to the right'
  , '下一组': 'Next Group'
  , '例如：工业园夜间巡检': 'Example: Industrial Park Night Patrol'
  , '任务名称（可选）': 'Task Name (Optional)'
  , '不填则默认使用标题': 'Uses the title when left blank'
  , '请输入起点关键词': 'Enter start point keywords'
  , '请输入终点关键词': 'Enter destination keywords'
  , '预估距离': 'Estimated Distance'
  , '预计时间': 'Estimated Time'
  , '请输入服务地址关键词': 'Enter service address keywords'
  , '请输入联系电话': 'Enter a contact phone number'
  , '请描述任务场景、需求内容和时间要求': 'Describe the task, requirements, and timing'
  , '禁止分包': 'No Subcontracting'
  , '接单机器人独立完成全部任务，执行中不能转交。': 'The assigned robot must complete the task without a handoff.'
  , '两段协作': 'Two-Stage Collaboration'
  , '允许分包': 'Allow Subcontracting'
  , '接单时必须锁定两台机器人、交接点和分账比例。': 'Lock both robots, the handoff point, and revenue split when accepting.'
  , '距离': 'Distance'
  , '当前阶段': 'Current Phase'
  , '当前阶段由平台提供任务补助，用户无需先行支付 RoboCoin。': 'The platform currently funds task subsidies; users do not pay RoboCoin upfront.'
  , '后续钱包': 'Future Wallet Support'
  , '后续接入用户钱包后，将从用户钱包中冻结对应 RoboCoin。': 'Once user wallets are enabled, the required RoboCoin will be reserved from the user wallet.'
  , '任务完成': 'Task Completion'
  , '任务完成后按实际服务结果结算，当前先仅展示平台补助额度。': 'Settlement follows actual results. For now, only the platform subsidy is shown.'
  , '请最后确认任务清单': 'Review the Task Checklist'
  , '发现信息不对，直接在对应清单项里修改；确认无误后再发布。': 'Edit any incorrect checklist item, then publish after confirming all details.'
  , '接驳预估：': 'Shuttle Estimate:'
  , '发布前摘要': 'Pre-Publish Summary'
  , '我的任务': 'My Tasks'
  , '当前账号暂无已发布任务，请确认登录账号后刷新': 'No published tasks for this account. Check the account and refresh.'
  , '发布状态': 'Publication Status'
  , '创建时间': 'Created At'
  , '编辑': 'Edit'
  , '任务状态筛选': 'Filter by Task Status'
  , '按机器人类型筛选': 'Filter by Robot Type'
  , 'DeRAS自动审核设置': 'DeRAS Auto-Review Settings'
  , '当前先用于上门服务：校验发布者信誉、平台补助、联系方式和服务地点真实性；未通过或不确定的任务会进入人工复核。': 'Currently used for on-site tasks to verify publisher reputation, subsidy, contact, and location. Uncertain tasks go to manual review.'
  , '最低信誉分': 'Minimum Reputation'
  , '地点误差阈值': 'Location Error Threshold'
  , '并发候选数': 'Concurrent Candidates'
  , '邀请超时秒数': 'Invitation Timeout (sec)'
  , '上门自动审核': 'On-Site Auto Review'
  , '已被接单': 'Accepted'
  , '我的': 'Mine'
  , '我的派单进度': 'My Dispatch Progress'
  , '预计到手': 'Estimated Earnings'
  , '人工通过': 'Approve Manually'
  , '驳回复核': 'Reject Review'
  , '关闭任务': 'Close Task'
  , '暂无任务': 'No Tasks'
  , '按白皮书标准转账费 1% 计入平台/AI-UBI 费用池': 'A 1% transfer fee goes to the platform/AI-UBI pool under the white paper.'
  , '接单时锁定执行方案': 'Lock Execution Plan on Acceptance'
  , '整单执行': 'Single-Robot Execution'
  , '选择我的在线机器人': 'Choose My Online Robot'
  , '第二段机器人': 'Second-Stage Robot'
  , '选择已审核且在线的协作机器人': 'Choose a verified online partner robot'
  , '交接地点': 'Handoff Location'
  , '交接点名称或详细地址': 'Handoff point name or address'
  , '交接纬度': 'Handoff Latitude'
  , '交接经度': 'Handoff Longitude'
  , '第一段分账': 'Stage 1 Share'
  , '% / 第二段': '% / Stage 2'
  , '第一段分账比例': 'Stage 1 Revenue Share'
  , '第二段机器人确认前不能开始履约；确认后机器人、交接点和分账比例都不能中途修改。': 'Execution starts after the second robot confirms. Robots, handoff, and shares cannot then be changed.'
  , '像打车订单一样追踪服务机器人：发布者看机器人进度，服务者推进机器人状态。': 'Track service robots like a ride order: publishers monitor progress and providers update status.'
  , '· 分账': '· Revenue Split'
  , '确认第二段协作': 'Confirm Stage 2'
  , '拒绝': 'Reject'
  , '发起交接': 'Start Handoff'
  , '输入交接码并接管': 'Enter Handoff Code'
  , '任务类型': 'Task Type'
  , '任务发布者': 'Publisher'
  , '服务者': 'Provider'
  , '服务地点': 'Service Location'
  , '查看机器人详情': 'View Robot Details'
  , '服务者操作台': 'Provider Console'
  , '服务者优先推进机器人状态；地图追踪由发布者侧查看。当前只展示必要地点和下一步动作。': 'Providers update robot status; publishers view map tracking. Only the required location and next action are shown.'
  , '接驳终点': 'Shuttle Destination'
  , '服务计时': 'Service Timer'
  , '开始计费': 'Billing Started'
  , '结束计费': 'Billing Ended'
  , '当前目标': 'Current Target'
  , '距上车点': 'To Pickup Point'
  , '上车点到下车点': 'Pickup to Drop-Off'
  , '预计耗时': 'Estimated Duration'
  , '可信履约详情': 'Trusted Execution Details'
  , 'DeRAS 日志、RoboCoin 结算凭证和 PoT 履约证明已收起，需要核验时再打开。': 'DeRAS logs, RoboCoin receipts, and PoT proofs are collapsed. Open them when verification is needed.'
  , '任务流程已结束。': 'The task workflow has ended.'
  , '备用：注册页一行安装成功后 Agent 会自动运行；如果终端被关闭，可用下面命令重新启动轮询和心跳': 'Fallback: the Agent starts after installation. Use this command to restart polling and heartbeats if needed.'
  , '复制备用启动命令': 'Copy Fallback Start Command'
  , 'DeRAS履约日志': 'DeRAS Execution Log'
  , 'RoboCoin结算凭证': 'RoboCoin Settlement Receipt'
  , '服务时长': 'Service Duration'
  , '最终应付': 'Final Amount Due'
  , '服务方收入': 'Provider Earnings'
  , '结算状态': 'Settlement Status'
  , 'PoT履约证明': 'PoT Execution Proof'
  , '证明状态': 'Proof Status'
  , '证明数量': 'Proof Count'
  , '条': 'items'
  , '最近摘要': 'Latest Summary'
  , '证据类型': 'Evidence Type'
  , '当前阶段只生成离线可审计证明，不做上链和真实币结算；后续可把摘要锚定到链上。': 'This phase creates offline auditable proofs only. On-chain anchoring and token settlement can be added later.'
  , '服务身份': 'Service Identity'
  , '订单阶段': 'Order Phase'
  , '如果现场机器人与这里展示的图片、类型或能力明显不一致，你可以在确认开始或确认结束时拒绝并提交仲裁。': 'If the on-site robot differs from the shown photo, type, or capability, reject it during start or completion confirmation and request arbitration.'
  , '拒绝后订单会进入待仲裁状态，进行中的任务列表将不再继续推进。管理员后续会根据理由和凭证进行人工审核。': 'After rejection, the order enters arbitration and stops progressing. An administrator reviews the reason and evidence.'
  , '拒绝理由（必填）': 'Rejection Reason (Required)'
  , '请说明为什么拒绝，例如：现场机器人与封面不一致、机器人类型不对、服务未达到开始条件、清扫结果不合格等。': 'Explain the rejection, such as robot mismatch, wrong type, unmet start conditions, or unacceptable results.'
  , '现场照片（选填）': 'On-Site Photo (Optional)'
  , '重新上传凭证': 'Replace Evidence'
  , '上传现场照片': 'Upload On-Site Photo'
  , '可选，但建议上传机器人或服务结果照片': 'Optional; a robot or service result photo is recommended'
  , '查看你的全部订单、已完成服务、机器人钱包和账号资料。进行中的任务只保留实时处理，历史订单统一沉淀到这里。': 'View all orders, completed services, robot wallets, and account details. Historical orders are stored here.'
  , '刷新数据': 'Refresh Data'
  , '更换头像': 'Change Avatar'
  , '信誉分': 'Reputation'
  , '钱包总额': 'Wallet Total'
  , '全部订单': 'All Orders'
  , '仲裁中': 'In Arbitration'
  , '我是发布者': 'As Publisher'
  , '我是服务者': 'As Provider'
  , '订单ID': 'Order ID'
  , '交接：': 'Handoff:'
  , '结算': 'Settlement'
  , '预付': 'Prepaid'
  , '应付': 'Due'
  , '/ 退': '/ Refund'
  , '/ 补': '/ Additional'
  , '更新时间': 'Updated At'
  , '确认协作': 'Confirm Collaboration'
  , '凭证': 'Receipt'
  , '日志': 'Logs'
  , '暂无已发布任务': 'No Published Tasks'
  , '复核/仲裁': 'Review / Arbitration'
  , '处理状态': 'Processing Status'
  , '处理中': 'Processing'
  , '已处理': 'Processed'
  , '已驳回': 'Rejected'
  , '事件类型': 'Event Type'
  , '异常复核': 'Exception Review'
  , '人工仲裁': 'Manual Arbitration'
  , '处理结果': 'Result'
  , '仲裁结果': 'Arbitration Result'
  , '全部记录': 'All Records'
  , '已闭环': 'Closed'
  , '仲裁记录': 'Arbitration Records'
  , '高风险': 'High Risk'
  , '· 订单 #': '· Order #'
  , '证明类型': 'Proof Type'
  , '提交时间': 'Submitted At'
  , '查看订单日志': 'View Order Logs'
  , '复制复核信息': 'Copy Review Details'
  , '暂无复核/仲裁记录': 'No Review or Arbitration Records'
  , '机器人钱包': 'Robot Wallets'
  , '注册新机器人': 'Register New Robot'
  , '链上冻结资产': 'On-Chain Frozen Assets'
  , '当前为平台补助阶段，暂不从用户钱包扣款；后续接入链上钱包后，这里会显示冻结、划转、退款和交易哈希。': 'The platform currently funds subsidies. Frozen funds, transfers, refunds, and transaction hashes will appear after on-chain wallets are enabled.'
  , '机器人钱包总额': 'Robot Wallet Total'
  , '链上冻结中': 'Frozen On-Chain'
  , '待接入': 'Pending Integration'
  , '平台补助中': 'Platform Subsidy Active'
  , '待结算': 'Pending Settlement'
  , '订单完成后划转': 'Transferred After Completion'
  , '地域限制：': 'Region Restriction:'
  , '机器人档案库': 'Robot Profiles'
  , '暂无机器人钱包': 'No Robot Wallets'
  , '账号资料': 'Account Profile'
  , '昵称': 'Nickname'
  , '国际区号': 'Country Code'
  , '账号安全': 'Account Security'
  , '当前密码': 'Current Password'
  , '新密码': 'New Password'
  , '确认新密码': 'Confirm New Password'
  , '凭证编号': 'Receipt ID'
  , '复制编号': 'Copy ID'
  , '复制凭证信息': 'Copy Receipt Details'
  , '打印凭证': 'Print Receipt'
  , '退回': 'Refunded'
  , '补扣': 'Additional Charge'
  , '链上资产占位': 'On-Chain Asset Placeholder'
  , '当前阶段由平台提供任务补助，暂不执行真实链上冻结。后续接入用户钱包后，本凭证会展示冻结交易、划转交易、退款交易和链上哈希。': 'The platform currently funds subsidies without on-chain freezing. Future receipts will show freeze, transfer, refund, and transaction hashes.'
  , '履约摘要': 'Execution Summary'
  , '开始：': 'Start:'
  , '结束：': 'End:'
  , '服务时长：': 'Service Duration:'
  , '仲裁/复核结果': 'Arbitration / Review Result'
  , '可信证据摘要': 'Trusted Evidence Summary'
  , '订单履约日志': 'Order Execution Log'
  , '订单 #': 'Order #'
  , '暂无履约日志': 'No Execution Logs'
  , 'RoboCoin H5 首页': 'RoboCoin Mobile Home'
  , '自主机器人执行服务任务': 'Autonomous Robot Service Tasks'
  , '服务暂不可用': 'Service Unavailable'
  , '机器人现场服务': 'On-Site Robot Service'
  , '打开个人信息': 'Open Profile'
  , '重试': 'Retry'
  , '台设备': 'Devices'
  , '条任务': 'Tasks'
  , '工作台状态': 'Workspace Status'
  , '刷新动态': 'Refresh Activity'
  , '返回 H5 首页': 'Back to Mobile Home'
  , '返回': 'Back'
  , '机器人设备': 'Robot Devices'
  , '刷新机器人': 'Refresh Robots'
  , '完整注册与 SDK 安装': 'Full Registration and SDK Installation'
  , '请在电脑端机器人中心完成设备资料、钱包及 SDK 绑定。': 'Complete the device profile, wallet, and SDK binding in the desktop Robot Center.'
  , '电脑端入口': 'Desktop Access'
  , '打开电脑端机器人中心': 'Open Desktop Robot Center'
  , '账户中心': 'Account Center'
  , '已注册机器人': 'Registered Robots'
  , '连接状态': 'Connection Status'
  , 'H5 主要导航': 'Mobile Primary Navigation'
  , '控制台': 'Console'
  , '手机任务导航': 'Mobile Task Navigation'
  , '机器人任务执行现场': 'Robot Task Operations'
  , '登录后发布真实任务': 'Sign In to Publish Real Tasks'
  , '任务会写入 DeRAS 平台，并同步显示在电脑端的任务中心。': 'Tasks are saved to DeRAS and synchronized with the desktop Task Center.'
  , '前往登录': 'Go to Sign In'
  , '机器人任务发布': 'Robot Task Publishing'
  , '任务步骤': 'Task Steps'
  , '前进 10 m → 旋转 360° → 前进 10 m': 'Move 10 m → turn 360° → move 10 m'
  , '旋转时长（秒）': 'Turn Duration (sec)'
  , '例如：园区 A 栋夜间巡检': 'Example: Building A Night Patrol'
  , '在地图上选择起点': 'Choose the Start Point on the Map'
  , '选择任务起点': 'Choose Task Start Point'
  , '输入起点关键词': 'Enter start point keywords'
  , '在地图上选择终点': 'Choose the Destination on the Map'
  , '选择任务终点': 'Choose Task Destination'
  , '输入终点关键词': 'Enter destination keywords'
  , '在地图上选择服务地址': 'Choose the Service Address on the Map'
  , '输入服务地址关键词': 'Enter service address keywords'
  , '手机号或国际联系电话': 'Phone or International Contact Number'
  , '现场要求、注意事项、交付标准': 'On-site requirements, precautions, and delivery standards'
  , '提交后会进入正式任务中心，并按平台现有审核与派单规则流转。': 'After submission, the task enters the Task Center and follows platform review and dispatch rules.'
  , '返回发布中心': 'Back to Publishing'
  , '刷新进度': 'Refresh Progress'
  , '进入进行中任务': 'Open Active Tasks'
  , '查看任务市场': 'View Task Market'
  , '查看我的发布': 'View My Published Tasks'
  , '候选机器人': 'Candidate Robots'
  , '已参与派单': 'Included in Dispatch'
  , '最优候选或已接单': 'Best Candidate or Accepted'
  , '无候选扫描': 'No-Candidate Scan'
  , '系统仍会继续重试': 'The System Will Keep Retrying'
  , '兜底状态': 'Fallback Status'
  , '派单时间线': 'Dispatch Timeline'
  , '暂无派单时间线。': 'No dispatch timeline.'
  , '· 分数': '· Score'
  , 'DeRAS还没有生成候选机器人。': 'DeRAS has not generated any candidate robots yet.'
  , '当前暂无合适机器人，系统已开放任务市场抢单。': 'No suitable robot is available. The task is now open in the task market.'
  , '可以等待机器人主动接单，也可以返回发布中心调整任务类型、地点、时间或平台补助。': 'Wait for a robot to accept, or adjust the type, location, time, or subsidy.'
  , '重新派单': 'Redispatch'
  , '提高平台补助': 'Increase Subsidy'
  , '修改时间/地址': 'Edit Time / Address'
  , '调整平台补助': 'Adjust Platform Subsidy'
  , '当前阶段仍由平台提供补助，调整后 DeRAS 会取消旧邀请并重新派单。': 'The platform still funds the subsidy. DeRAS cancels old invitations and redispatches after an adjustment.'
  , '确认调整': 'Confirm Adjustment'
  , '我的派单邀请': 'My Dispatch Invitations'
  , '服务者专用接单台：集中查看 DeRAS 推荐、倒计时、候选评分和处理结果。': 'Provider console for DeRAS recommendations, countdowns, scores, and results.'
  , '刷新邀请': 'Refresh Invitations'
  , '已接受': 'Accepted'
  , '已拒绝': 'Rejected'
  , '已超时': 'Expired'
  , '谁先接受谁锁单，其他候选会自动取消。': 'The first acceptance locks the task; other invitations are cancelled.'
  , '倒计时': 'Countdown'
  , '候选分': 'Candidate Score'
  , 'DeRAS 推荐原因': 'DeRAS Recommendation'
  , 'DeRAS 离线调度凭证：记录任务、候选机器人、评分、排名、邀请时间和超时策略。': 'DeRAS offline dispatch receipt with task, candidate, score, rank, invitation time, and timeout policy.'
  , '暂无派单邀请': 'No Dispatch Invitations'
  , '机器人中心': 'Robot Center'
  , '机器人档案': 'Robot Profile'
  , '刷新档案': 'Refresh Profile'
  , '编辑档案': 'Edit Profile'
  , '未找到机器人档案': 'Robot Profile Not Found'
  , '返回机器人中心': 'Back to Robot Center'
  , '建档': 'Profile Created'
  , '% 完整': '% Complete'
  , '机器人履历统计': 'Robot History Statistics'
  , '累计接单': 'Total Accepted'
  , '全部任务记录': 'All Task Records'
  , '完成率': 'Completion Rate'
  , '单已完成': 'Completed'
  , '累计净收益': 'Total Net Earnings'
  , '档案评分': 'Profile Score'
  , '平台记录': 'Platform Record'
  , '身份资料': 'Identity Profile'
  , '制造商 / 品牌': 'Manufacturer / Brand'
  , '例如：Unitree': 'Example: Unitree'
  , '型号': 'Model'
  , '例如：Go2 EDU': 'Example: Go2 EDU'
  , '设备序列号': 'Device Serial Number'
  , '生产日期': 'Manufacture Date'
  , '选择日期': 'Choose Date'
  , '投入使用日期': 'Commission Date'
  , '收款钱包地址（接单前必填）': 'Payment Wallet (Required Before Accepting Tasks)'
  , '例如：0xFaA0d9A670b6CC505EeC57046edD2FdB7A03AB55': 'Example: 0xFaA0d9A670b6CC505EeC57046edD2FdB7A03AB55'
  , '可暂时留空；开启接单前必须填写有效的 EVM 钱包地址。': 'May be left blank for now; a valid EVM wallet is required before accepting tasks.'
  , '能力说明': 'Capabilities'
  , '档案备注': 'Profile Notes'
  , '设备与能力': 'Device and Capabilities'
  , '设备型号': 'Device Model'
  , '工控机': 'Controller'
  , '处理器': 'Processor'
  , 'SDK 版本': 'SDK Version'
  , '身份类型': 'Identity Type'
  , 'DDS 网卡': 'DDS Network Adapter'
  , '最近上报': 'Latest Report'
  , '暂无 SDK 设备上报': 'No SDK Device Reports'
  , '接单履历': 'Task History'
  , '· 取消': '· Cancelled'
  , '单 · 仲裁': '· Arbitrations'
  , '订单': 'Order'
  , '机器人收益': 'Robot Earnings'
  , '这台机器人还没有接单记录': 'This robot has no accepted task records'
  , '新的派单邀请': 'New Dispatch Invitation'
  , '剩余确认时间': 'Confirmation Time Left'
  , '· 距离': '· Distance'
  , '接受派单': 'Accept Dispatch'
  , '查看全部派单邀请': 'View All Dispatch Invitations'
  , 'DeRAS 订单中心': 'DeRAS Order Center'
  , 'DeRAS推荐原因': 'DeRAS Recommendation'
  , '候选排名 #': 'Candidate Rank #'
  , '· 候选分': '· Candidate Score'
  , '接单用户：': 'Provider:'
  , '拒绝派单': 'Reject Dispatch'
  , '已选地址：': 'Selected Address:'
  , '暂无候选地点，请输入关键词搜索。': 'No candidate locations. Enter keywords to search.'
  , '正在连接 Google Maps...': 'Connecting to Google Maps...'
  , '已确认此地址，系统将自动保存定位信息。': 'Address confirmed. Location data will be saved automatically.'
  , '搜索并选择候选地点后，可在地图上查看预览。': 'Search and choose a location to preview it on the map.'
  , '机器人GPS实时位置': 'Live Robot GPS Location'
  , '定位车辆': 'Locate Vehicle'
  , '预计到达': 'ETA'
  , 'GPS坐标': 'GPS Coordinates'
  , '定位来源': 'Location Source'
  , '目的地': 'Destination'
  , '速度/方向': 'Speed / Direction'
  , '起': 'START'
  , '上车点': 'Pickup Point'
  , '终': 'END'
  , '下车点': 'Drop-Off Point'
  , '已到达接驳起点': 'Arrived at Pickup Point'
  , '模拟等待乘客上车，确认后车辆继续前往终点。': 'Simulate passenger boarding, then continue to the destination.'
  , 'OK，前往终点': 'OK, Go to Destination'
  , '地图瓦片加载不稳定，当前已自动切换备用源': 'Map tiles are unstable; switched to the backup source'
  , 'GPS车辆': 'GPS Vehicle'
  , '服务点': 'Service Point'
  , '道路轨迹': 'Road Route'
  , '终端里出现': 'The terminal should display'
  , '和': 'and'
  , '，说明 TPM 验签通过；此时令牌会立即失效。': ', which means TPM verification passed. The token then expires immediately.'
  , '如果页面长时间显示离线，再由管理员指导执行': 'If the page remains offline, run this command with administrator guidance:'
  , '，它会检查服务状态、TPM权限、后端连接、绑定结果和最近心跳。': '. It checks service status, TPM permissions, backend connectivity, binding, and the latest heartbeat.'
  , '当前没有可用 Token，请先登录': 'No token is available. Sign in first.'
  , 'API Token 已复制': 'API token copied'
  , '复制失败，请手动复制 Token': 'Copy failed. Copy the token manually.'
  , '当前是管理员会话，请退出后使用普通用户账号': 'This is an administrator session. Sign out and use a standard user account.'
  , '已退出登录': 'Signed out'
  , '页面处理出现异常，请刷新页面后重试。': 'An unexpected page error occurred. Refresh the page and try again.'
  , '请填写机器人名称': 'Enter the robot name'
  , '请填写联系方式': 'Enter contact information'
  , '图片上传失败，请重试': 'Image upload failed. Try again.'
  , '如果工控机终端还在执行命令，请等它跑完；如果已经报错，请把终端输出发给管理员。': 'If the controller is still running the command, wait for it to finish. If it failed, send the terminal output to an administrator.'
  , '平台已收到 TPM 公钥，请先点击“确认这是我的设备”。': 'The platform received the TPM public key. Select "Confirm This Is My Device" first.'
  , '设备已确认但 Agent 还未在线，请检查工控机是否开机、网络是否能访问平台。管理员可使用排查命令进一步定位。': 'The device is confirmed but the Agent is offline. Check controller power and network access. An administrator can use the diagnostic command.'
  , '请选择地址': 'Choose an Address'
  , '选择位置': 'Choose Location'
  , '请输入地址关键词': 'Enter address keywords'
  , '地图服务正在加载，请稍候。': 'Map service is loading. Please wait.'
  , '当前网络无法访问 Google Maps，已自动切换备用地图；保存的仍是通用 WGS84 坐标。': 'Google Maps is unavailable. The backup map is active and locations are still saved as WGS84 coordinates.'
  , '地图服务准备好后即可搜索地址。': 'You can search once the map service is ready.'
  , '搜索地址后可对比多个候选地点，并在 Google 地图中确认最终位置。': 'Search, compare candidate locations, and confirm the final location on Google Maps.'
  , '全国': 'Worldwide'
  , '当前选择': 'Current Selection'
  , '地图服务仍未就绪，请稍后重试': 'Map service is not ready. Try again later.'
  , '未找到匹配的位置': 'No Matching Location Found'
  , '一键命令绑定成功后会创建': 'After binding, the command creates the'
  , '后台服务，并每 30 秒向 DeRAS 上报一次 TPM 签名心跳。后续服务者点击出发、申请开始或申请结束时，SDK 会自动向 DeRAS 上报。': 'background service and sends a TPM-signed heartbeat to DeRAS every 30 seconds. The SDK also reports departure, start, and completion actions automatically.'
  , 'DeRAS 已生成一次性挑战，正在等待机器人端 SDK 自动签名上报。 SDK 会调用 TPM 私钥签名，平台用注册时保存的公钥验签，确认响应来自绑定过的机器人设备。 验签通过后系统会自动推进当前订单阶段。': 'DeRAS created a one-time challenge and is waiting for the robot SDK signature. The SDK signs with the TPM private key, and the platform verifies it with the registered public key before advancing the order.'
  , '取消任务': 'Cancel Task'
  , '单': 'orders'
  , '任务加载失败': 'Failed to Load Tasks'
  , '任务市场加载失败': 'Failed to Load Task Market'
  , '任务市场请求失败，请稍后重试。': 'Task market request failed. Try again later.'
  , '任务提交失败': 'Task Submission Failed'
  , '任务提交失败，请检查任务信息后重试。': 'Task submission failed. Check the details and try again.'
  , '任务修改成功': 'Task Updated'
  , '任务信息和平台补助记录已更新。': 'Task details and subsidy records were updated.'
  , '发布需求成功': 'Task Published'
  , '需求已发布，平台补助已记录，正在等待后续匹配。': 'The task was published with its subsidy and is waiting for matching.'
  , '任务取消失败': 'Failed to Cancel Task'
  , '任务已取消': 'Task Cancelled'
  , '未检测到登录用户': 'No Signed-In User Detected'
  , '正在保存修改': 'Saving Changes'
  , '正在发布需求': 'Publishing Task'
  , 'DeRAS设置读取失败，已使用页面默认值。': 'Failed to load DeRAS settings. Default values are in use.'
  , 'DeRAS设置保存失败': 'Failed to Save DeRAS Settings'
  , 'DeRAS设置保存失败，请稍后重试。': 'Failed to save DeRAS settings. Try again later.'
  , 'DeRAS设置已保存': 'DeRAS Settings Saved'
  , '协作机器人列表加载失败': 'Failed to Load Partner Robots'
  , '协作机器人列表加载失败，请稍后重试。': 'Failed to load partner robots. Try again later.'
  , '派单时间线加载失败': 'Failed to Load Dispatch Timeline'
  , '派单时间线请求失败，请稍后重试。': 'Dispatch timeline request failed. Try again later.'
  , '关闭后该任务会从已通过市场移除，确定继续吗？': 'Closing this task removes it from the approved market. Continue?'
  , '确定关闭': 'Close Task'
  , '确认人工通过该任务？通过后会进入任务市场，服务者可以接单。': 'Approve this task? It will enter the task market for providers to accept.'
  , 'DeRAS人工复核': 'DeRAS Manual Review'
  , '确认通过': 'Approve'
  , '请先登录后再接单': 'Sign in before accepting a task'
  , '该任务已经被接单，等待服务者执行或取消后重新开放': 'This task was accepted. Wait for execution or for it to reopen after cancellation.'
  , '接单失败': 'Failed to Accept Task'
  , '接单成功': 'Task Accepted'
  , '接单请求失败，请稍后重试。': 'Task acceptance request failed. Try again later.'
  , '操作失败': 'Operation Failed'
  , '操作失败，请稍后重试。': 'Operation failed. Try again later.'
  , '进行中任务加载失败': 'Failed to Load Active Tasks'
  , '进行中任务请求失败': 'Active task request failed'
  , '流程推进失败': 'Failed to Advance Workflow'
  , '流程推进请求失败': 'Workflow request failed'
  , '仲裁提交失败': 'Failed to Submit Arbitration'
  , '仲裁提交请求失败': 'Arbitration request failed'
  , '请上传图片文件': 'Upload an image file'
  , '图片大小不能超过 8MB': 'The image must not exceed 8 MB'
  , '图片上传失败，接口没有返回可展示的URL': 'Image upload failed because no image URL was returned'
  , '凭证照片已上传': 'Evidence Photo Uploaded'
  , '请填写拒绝理由': 'Enter a rejection reason'
  , '订单已进入待仲裁': 'Order Sent to Arbitration'
  , '确认后两台机器人、交接点和分账比例不能中途修改。': 'After confirmation, the robots, handoff point, and revenue split cannot be changed.'
  , '稍后处理': 'Later'
  , '协作确认失败': 'Failed to Confirm Collaboration'
  , '两段协作方案已生效': 'Two-Stage Collaboration Activated'
  , '拒绝协作失败': 'Failed to Reject Collaboration'
  , '分包方案已取消，任务已重新开放': 'The subcontracting plan was cancelled and the task reopened'
  , '发起交接失败': 'Failed to Start Handoff'
  , '交接核验失败': 'Handoff Verification Failed'
  , '交接完成，第二段执行权已生效': 'Handoff complete. Stage 2 execution is active.'
  , '已取消接单，信誉分扣除10分，任务已重新开放': 'Acceptance cancelled. Reputation decreased by 10 and the task reopened.'
  , '已刷新车辆状态': 'Vehicle Status Refreshed'
  , '提交复核失败': 'Failed to Submit Review'
  , '已提交 DeRAS 复核，并写入履约日志': 'DeRAS review submitted and added to the execution log'
  , '派单进度加载失败': 'Failed to Load Dispatch Progress'
  , '派单进度请求失败': 'Dispatch progress request failed'
  , '重新派单失败': 'Redispatch Failed'
  , 'DeRAS已重新派单': 'DeRAS Redispatched the Task'
  , '重新派单请求失败': 'Redispatch request failed'
  , '补助调整失败': 'Failed to Adjust Subsidy'
  , '平台补助已调整，DeRAS正在重新派单': 'Subsidy adjusted. DeRAS is redispatching the task.'
  , '补助调整请求失败': 'Subsidy adjustment request failed'
  , '确认取消这个任务吗？取消后 DeRAS 会停止派单。': 'Cancel this task? DeRAS will stop dispatching it.'
  , '确认取消': 'Confirm Cancellation'
  , '再等等': 'Keep Waiting'
  , '派单邀请加载失败': 'Failed to Load Dispatch Invitations'
  , '派单邀请请求失败': 'Dispatch invitation request failed'
  , '确认接受这次 DeRAS 派单吗？接受后任务会立即锁定到你的机器人。': 'Accept this DeRAS dispatch? The task will be locked to your robot immediately.'
  , '确认接受': 'Confirm Acceptance'
  , '接受派单失败': 'Failed to Accept Dispatch'
  , '已接受派单': 'Dispatch Accepted'
  , '已接受派单，任务进入进行中订单': 'Dispatch accepted. The task is now active.'
  , '拒绝派单失败': 'Failed to Reject Dispatch'
  , '已拒绝派单': 'Dispatch Rejected'
  , '该派单邀请已超时，DeRAS正在尝试下一轮候选。': 'This invitation expired. DeRAS is trying the next candidates.'
  , '标记失败': 'Failed to Mark Message'
  , '已标记为已读': 'Marked as Read'
  , '全部已读失败': 'Failed to Mark All as Read'
  , '全部消息已标记为已读': 'All Messages Marked as Read'
  , '确认删除这条消息吗？删除后不会在消息中心显示。': 'Delete this message? It will no longer appear in the message center.'
  , '删除消息': 'Delete Message'
  , '确认删除': 'Confirm Delete'
  , '删除消息失败': 'Failed to Delete Message'
  , '消息已删除': 'Message Deleted'
  , '确认清空全部任务消息吗？清空后当前消息列表会变为空。': 'Clear all task messages? The message list will become empty.'
  , '确认清空': 'Confirm Clear'
  , '清空消息失败': 'Failed to Clear Messages'
  , '全部消息已清空': 'All Messages Cleared'
  , '0 分钟': '0 min'
  , 'DeRAS正在寻找机器人': 'DeRAS Is Searching for a Robot'
  , '任务已经进入进行中订单': 'The Task Is Now Active'
  , '候选机器人拒绝，DeRAS正在尝试下一台': 'Candidate declined. DeRAS is trying the next robot.'
  , '候选机器人超时，DeRAS正在重新派单': 'Candidate timed out. DeRAS is redispatching.'
  , '允许接单时确定两段协作': 'Set Two-Stage Collaboration When Accepting'
  , '可横向浏览并比较机器人类型，选中后点击下一步继续。': 'Browse and compare robot types, then select Next.'
  , '审核通过后会自动进入派单': 'Dispatch starts automatically after approval'
  , '已成功接单': 'Task Accepted'
  , '已扣费': 'Charged'
  , '已根据历史完成任务平均时长预估': 'Estimated from average completed task duration'
  , '已退款': 'Refunded'
  , '当前阶段由平台提供任务补助；后续接入用户钱包后，将从用户钱包中冻结对应 RoboCoin，任务完成后按实际服务结果结算。': 'The platform currently funds the subsidy. Future wallet support will reserve RoboCoin and settle it from actual results.'
  , '暂无历史完成任务，先按默认时长预估': 'No completed task history; using the default duration'
  , '暂无历史完成任务，已按默认服务时长预估。': 'No completed task history. The default service duration is used.'
  , '暂无新候选，任务已开放给服务者抢单': 'No new candidates. The task is open for providers.'
  , '未支付': 'Unpaid'
  , '未登录用户': 'Signed-Out User'
  , '未知状态': 'Unknown Status'
  , '未选择服务地址': 'No Service Address Selected'
  , '未选择终点': 'No Destination Selected'
  , '未选择起点': 'No Start Point Selected'
  , '禁止分包，整单履约': 'No Subcontracting; Single-Robot Execution'
  , '等待 DeRAS 同步派单状态': 'Waiting for DeRAS Dispatch Status'
  , '等待同步': 'Waiting for Sync'
  , '等待审核通过': 'Waiting for Approval'
  , '等待路线距离': 'Waiting for Route Distance'
  , '类型、在线、空闲、信誉分会参与候选排序': 'Type, online status, availability, and reputation affect candidate ranking'
  , '请在地图上确认服务地址': 'Confirm the service address on the map'
  , '请在地图上确认终点': 'Confirm the destination on the map'
  , '请在地图上确认起点': 'Confirm the start point on the map'
  , '请输入 7 至 15 位有效电话号码，可包含国际区号': 'Enter a valid 7-15 digit phone number, including an international prefix if needed'
  , '请输入任务描述': 'Enter a task description'
  , '请输入任务标题': 'Enter a task title'
  , '请选择服务类型': 'Choose a service type'
  , '请选择机器人类型': 'Choose a robot type'
  , '请选择预约时间': 'Choose a schedule time'
  , '起点和终点都在地图上确认后，系统会立即计算接驳距离、预计时间和平台补助额度。': 'Confirm both route points to calculate distance, time, and subsidy.'
  , '适合巡航、空中查看、轻量配送。': 'For patrol, aerial observation, and light delivery.'
  , '适合扫地、保洁、园区清扫。': 'For sweeping, housekeeping, and campus cleaning.'
  , '适合物品配送、楼宇转运。': 'For item delivery and building transfers.'
  , '选择起点和终点后自动计算': 'Calculated After Selecting Both Route Points'
  , '部分退款': 'Partially Refunded'
  , '预估接口暂不可用，当前使用默认预估。': 'Estimate service unavailable. Default estimate is in use.'
  , '预约时间必须晚于当前时间': 'Schedule time must be in the future'
  , '预约时间格式不正确': 'Invalid schedule time'
  , ' · 我的设备': ' · My Device'
  , '· 我的设备': '· My Device'
  , 'DeRAS 扫描候选': 'DeRAS Candidate Scan'
  , 'DeRAS人工复核未通过': 'DeRAS Manual Review Rejected'
  , 'DeRAS已记录该派单事件。': 'DeRAS recorded this dispatch event.'
  , 'DeRAS正在按类型、在线状态、空闲状态、信誉和距离筛选候选。': 'DeRAS is filtering candidates by type, online status, availability, reputation, and distance.'
  , '上一台候选机器人已拒绝，DeRAS正在自动尝试下一组候选。': 'The previous candidate declined. DeRAS is trying the next group.'
  , '上一台候选机器人已拒绝，系统正在尝试下一台': 'The previous candidate declined. Trying the next robot.'
  , '上一台候选机器人超时未响应，系统正在尝试下一台': 'The previous candidate timed out. Trying the next robot.'
  , '上一轮候选超时未响应，DeRAS正在重新派单。': 'The previous candidates timed out. DeRAS is redispatching.'
  , '两段必须选择不同机器人。': 'Choose different robots for the two stages.'
  , '任务已人工通过': 'Task Manually Approved'
  , '任务已关闭': 'Task Closed'
  , '任务已发布': 'Task Published'
  , '任务已经进入履约流程': 'The Task Entered Execution'
  , '任务已驳回': 'Task Rejected'
  , '任务进入 DeRAS 自动派单流程。': 'The task entered DeRAS automatic dispatch.'
  , '候选拒绝或超时后会自动尝试下一组机器人。': 'The next robot group is tried after a decline or timeout.'
  , '候选拒绝，正在重派': 'Candidate Declined; Redispatching'
  , '候选机器人会收到派单邀请。': 'Candidate robots receive dispatch invitations.'
  , '候选超时': 'Candidate Timed Out'
  , '到场服务': 'On-Site Service'
  , '地址未填写': 'Address Not Provided'
  , '审核中': 'Under Review'
  , '寻找机器人': 'Finding a Robot'
  , '已发出派单邀请': 'Dispatch Invitation Sent'
  , '已发邀请': 'Invitation Sent'
  , '已向候选机器人发出邀请，等待对方确认。': 'Invitation sent to a candidate robot; waiting for confirmation.'
  , '开放抢单兜底': 'Open-Market Fallback'
  , '当前任务缺少坐标，无法计算距离。': 'Task coordinates are missing; distance cannot be calculated.'
  , '当前任务缺少坐标，暂时无法计算距离。': 'Task coordinates are missing; distance is temporarily unavailable.'
  , '接驳服务': 'Shuttle Service'
  , '暂无新候选，任务仍开放给服务者抢单': 'No new candidates. The task remains open to providers.'
  , '未分类': 'Uncategorized'
  , '未知机器人': 'Unknown Robot'
  , '未通过': 'Not Approved'
  , '机器人已接受派单': 'Robot Accepted the Dispatch'
  , '机器人已锁定任务，订单进入履约流程。': 'A robot locked the task and execution has started.'
  , '派单事件': 'Dispatch Event'
  , '点击按钮后，浏览器会请求定位权限。电脑定位精度取决于系统、Wi-Fi 和浏览器环境。': 'The browser requests location permission. Accuracy depends on the system, Wi-Fi, and browser.'
  , '确认驳回': 'Confirm Rejection'
  , '等待机器人确认': 'Waiting for Robot Confirmation'
  , '等待某台机器人接受后锁单。': 'Waiting for a robot to accept and lock the task.'
  , '类型匹配、在线状态、空闲状态和信誉分会参与推荐': 'Type, online status, availability, and reputation affect recommendations'
  , '系统正在按类型、在线状态、空闲状态和信誉分筛选候选机器人': 'Filtering candidate robots by type, online status, availability, and reputation'
  , '终点未填': 'Destination Not Provided'
  , '自动派单暂未找到候选，任务已在任务市场开放兜底。': 'Automatic dispatch found no candidate. The task is open in the task market.'
  , '自动派单暂未找到候选，当前开放给服务者抢单': 'Automatic dispatch found no candidate. The task is open to providers.'
  , '自动派单暂未找到合适机器人，任务已开放给服务者抢单；建议检查任务类型、服务地点或提高平台补助。': 'No suitable robot found. The task is open to providers; check its type, location, or subsidy.'
  , '请填写交接地点。': 'Enter a handoff location.'
  , '请填写有效的交接经纬度。': 'Enter valid handoff coordinates.'
  , '请输入驳回原因，用户会在任务列表中看到该说明。': 'Enter a rejection reason. The user will see it in the task list.'
  , '请选择执行第一段的在线机器人。': 'Choose an online robot for stage 1.'
  , '请选择执行第二段的协作机器人。': 'Choose a partner robot for stage 2.'
  , '起点未填': 'Start Point Not Provided'
  , '起点未填写': 'Start Point Not Provided'
  , '这是直线距离，可作为接单参考；真实路线距离后续可以再接地图路线规划。': 'This straight-line distance is for reference. Route planning can provide actual travel distance later.'
  , '重派/兜底': 'Redispatch / Fallback'
  , 'DeRAS 正在根据机器人类型、SDK在线状态、距离、信誉和历史响应率寻找候选。': 'DeRAS is finding candidates by robot type, SDK status, distance, reputation, and response history.'
  , 'SV-待生成': 'SV-Pending'
  , '你可以继续等待，也可以调整任务信息提高匹配概率。': 'Keep waiting or adjust the task to improve matching.'
  , '发送邀请': 'Send Invitation'
  , '已向候选机器人发送邀请，等待服务者确认。': 'Invitation sent to a candidate robot; waiting for provider confirmation.'
  , '接受派单被阻断': 'Dispatch Acceptance Blocked'
  , '派单扫描': 'Dispatch Scan'
  , '等待确认': 'Waiting for Confirmation'
  , '系统会持续扫描在线且空闲的机器人。': 'The system keeps scanning online, available robots.'
  , '自动派单暂未找到合适机器人，任务已开放抢单。': 'No suitable robot found. The task is open for acceptance.'
  , '调度凭证生成': 'Dispatch Receipt Created'
  , '调度凭证确认': 'Dispatch Receipt Confirmed'
  , '距服务点': 'To Service Point'
  , '距目标点': 'To Target'
  , '距离未知': 'Distance Unknown'
  , '到家服务': 'Home Service'
  , '当前机器人暂不方便执行该任务': 'The Current Robot Cannot Perform This Task'
  , '待确认': 'Pending Confirmation'
  , '服务地址未填写': 'Service Address Not Provided'
  , '确认拒绝': 'Confirm Rejection'
  , '等待心跳': 'Waiting for Heartbeat'
  , '终点未填写': 'Destination Not Provided'
  , '请填写拒绝原因': 'Enter a rejection reason'
  , '请输入拒绝原因，DeRAS会继续尝试下一组候选机器人。': 'Enter a reason. DeRAS will try the next candidate group.'
  , 'DeRAS会继续寻找其他合适机器人。': 'DeRAS will keep finding suitable robots.'
  , 'DeRAS会自动尝试下一轮候选机器人。': 'DeRAS will automatically try the next candidates.'
  , 'DeRAS使用数据库原子锁保证同一任务只会被一个机器人接走；如果别人先接受，你的邀请会自动取消。': 'DeRAS locks each task to one robot. Your invitation is cancelled if another robot accepts first.'
  , '不用再处理这条邀请，DeRAS已经取消当前候选。': 'No action is needed. DeRAS cancelled this candidate.'
  , '任务已被其他机器人锁定': 'Task Locked by Another Robot'
  , '你已拒绝该任务': 'You Rejected This Task'
  , '你已接受该任务': 'You Accepted This Task'
  , '出发': 'Depart'
  , '到达': 'Arrive'
  , '已读': 'Read'
  , '开始': 'Start'
  , '待确认开始': 'Start Confirmation Pending'
  , '待确认结束': 'Completion Confirmation Pending'
  , '接单': 'Accept Task'
  , '接受后立即锁单': 'Acceptance Locks the Task Immediately'
  , '无需重复操作。': 'No further action is required.'
  , '本次邀请已超时': 'This Invitation Expired'
  , '本轮可能同时邀请多台机器人，谁先接受谁锁定任务，其他邀请会自动取消。': 'Several robots may be invited. The first acceptance locks the task and cancels the others.'
  , '派单': 'Dispatch'
  , '派单进度': 'Dispatch Progress'
  , '派单邀请已处理': 'Dispatch Invitation Processed'
  , '订单已进入进行中任务，请按流程点击出发、开始和结束。': 'The order is active. Follow the departure, start, and completion steps.'
  , '该派单邀请已处理。': 'This dispatch invitation was processed.'
  , '该邀请已取消，通常表示其他候选机器人已经先一步锁定任务。': 'This invitation was cancelled, usually because another robot locked the task first.'
  , '该邀请已拒绝，DeRAS已继续寻找其他候选机器人。': 'This invitation was rejected. DeRAS is finding another robot.'
  , '该邀请已接受，任务已经进入进行中订单。': 'This invitation was accepted and the task is now active.'
  , '该邀请已超时，DeRAS会自动流转到下一轮候选。': 'This invitation expired. DeRAS will try the next candidates.'
  , '请输入拒绝原因，DeRAS会继续尝试派给下一台候选机器人。': 'Enter a reason. DeRAS will try the next candidate robot.'
  , 'DeRAS 已记录该履约事件。': 'DeRAS recorded this execution event.'
  , 'DeRAS 已通过接单，请安排机器人出发。': 'DeRAS accepted the task. Prepare the robot to depart.'
  , 'DeRAS 正在同步当前订单的可执行指令。': 'DeRAS is syncing available order actions.'
  , 'GPS 超时未更新': 'GPS Update Timed Out'
  , 'SDK Agent 重启命令': 'SDK Agent Restart Command'
  , 'SDK/TPM 身份心跳': 'SDK/TPM Identity Heartbeat'
  , 'SDK验证已通过，但订单状态同步请求失败，请重试。': 'SDK verification passed, but order sync failed. Try again.'
  , 'SDK验证挑战生成失败': 'Failed to Create SDK Verification Challenge'
  , 'SDK验证未通过，请检查工控机SDK或TPM。': 'SDK verification failed. Check the controller SDK or TPM.'
  , 'SDK验证状态读取失败，请检查后端服务。': 'Failed to read SDK verification status. Check the backend service.'
  , 'SDK验证通过': 'SDK Verified'
  , 'SDK验证通过，正在同步订单状态。': 'SDK verified. Syncing order status.'
  , 'TDengine 返回的定位状态不是实时数据，请检查车辆定位链路。': 'TDengine location data is not live. Check the vehicle location pipeline.'
  , 'TPM 心跳在线': 'TPM Heartbeat Online'
  , '两段协作已完成': 'Two-Stage Collaboration Complete'
  , '两段方案已锁定': 'Two-Stage Plan Locked'
  , '交接完成，第二段执行中': 'Handoff Complete; Stage 2 Active'
  , '交接码已复制，请现场交给第二段机器人': 'Handoff code copied. Give it to the stage 2 robot on site.'
  , '交接码应为 32 位字符': 'The handoff code must contain 32 characters'
  , '任务已完成': 'Task Completed'
  , '任务已完成。': 'Task completed.'
  , '任务已完成，订单流程结束。': 'Task completed. The order workflow has ended.'
  , '任务已开始，完成后请申请结束服务。': 'The task started. Request completion when finished.'
  , '任务流程已结束': 'Task Workflow Ended'
  , '例如：机器人临时不可用 / 无法按时服务': 'Example: Robot unavailable / Cannot serve on time'
  , '例如：计划变更 / 服务不需要了': 'Example: Plans changed / Service no longer needed'
  , '例如：车辆长时间未移动 / GPS不更新 / SDK离线': 'Example: Vehicle stopped / GPS stale / SDK offline'
  , '再想想': 'Not Now'
  , '出发节点需要 SDK/TPM 验签，通过后证明是绑定机器人推进流程。': 'Departure requires SDK/TPM verification to prove the bound robot advanced the workflow.'
  , '分包方案已取消': 'Subcontracting Plan Cancelled'
  , '刷新车辆状态': 'Refresh Vehicle Status'
  , '前往接驳终点': 'Go to Shuttle Destination'
  , '前往接驳起点': 'Go to Shuttle Start Point'
  , '协作方案已锁定，等待第一段机器人到达交接点。': 'The collaboration plan is locked. Waiting for the stage 1 robot at the handoff point.'
  , '发布者主要关注车辆位置、可信状态和需要确认的关键节点。': 'Publishers monitor vehicle location, trust status, and required confirmations.'
  , '发布者已确认开始，计时正在实时走动；服务者申请结束后仍会继续计时，直到发布者确认结束。': 'The publisher confirmed the start. Timing continues until the publisher confirms completion.'
  , '发布者确认开始，服务时长开始计入 RoboCoin 结算。': 'The publisher confirmed the start. Service time now counts toward settlement.'
  , '发布者确认开始，车辆进入接驳第二段并开始计时。': 'The publisher confirmed the start. Stage 2 and timing are active.'
  , '发布者确认结束，DeRAS 生成最终结算凭证。': 'The publisher confirmed completion. DeRAS created the final receipt.'
  , '实时定位': 'Live Location'
  , '尚未开始计时': 'Timing Not Started'
  , '履约记录': 'Execution Record'
  , '已创建': 'Created'
  , '已生成凭证': 'Receipt Created'
  , '已申请开始接驳，等待发布者确认后开始计时。': 'Shuttle start requested. Waiting for publisher confirmation to begin timing.'
  , '已申请开始服务，等待发布者确认后开始计时。': 'Service start requested. Waiting for publisher confirmation to begin timing.'
  , '已申请开始服务，等待发布者确认开始计时': 'Service start requested. Waiting for publisher confirmation.'
  , '已申请开始服务，等待用户确认后开始计时。': 'Service start requested. Waiting for user confirmation to begin timing.'
  , '已申请结束服务，等待发布者确认结算。': 'Service completion requested. Waiting for publisher settlement confirmation.'
  , '已申请结束，等待发布者确认结算。': 'Completion requested. Waiting for publisher settlement confirmation.'
  , '已结算': 'Settled'
  , '已记录': 'Recorded'
  , '已验证': 'Verified'
  , '开始服务': 'Start Service'
  , '当前订单还没有拿到车辆真实经纬度，地图会使用模拟坐标兜底展示。': 'Live vehicle coordinates are unavailable. The map is using fallback coordinates.'
  , '当前阶段先展示平台补助和预估凭证；后续接入链上钱包后，这里会对应冻结、划转和手续费记录。': 'This phase shows subsidy estimates. Future wallet support will show freezes, transfers, and fees.'
  , '待复核': 'Pending Review'
  , '我是接单人': 'I Am the Provider'
  , '我是第二段协作方': 'I Am the Stage 2 Partner'
  , '执行权已切换到第二段机器人，请按当前流程推进任务。': 'Execution moved to the stage 2 robot. Continue with the current workflow.'
  , '拒绝协作': 'Reject Collaboration'
  , '拒绝后整份方案取消，原任务重新开放。请输入原因。': 'Rejecting cancels the plan and reopens the task. Enter a reason.'
  , '拒绝并仲裁': 'Reject and Arbitrate'
  , '拒绝开始并仲裁': 'Reject Start and Arbitrate'
  , '拒绝开始服务': 'Reject Service Start'
  , '拒绝确认并进入仲裁': 'Reject Confirmation and Arbitrate'
  , '拒绝结束并仲裁': 'Reject Completion and Arbitrate'
  , '拒绝结束服务': 'Reject Service Completion'
  , '挑战已过期': 'Challenge Expired'
  , '挑战已过期，请重新点击流程按钮生成新挑战。': 'The challenge expired. Select the workflow action again to create a new one.'
  , '接单人主动取消接单': 'Provider Cancelled Acceptance'
  , '接口暂未返回任务类型': 'Task Type Not Returned'
  , '接驳上车点': 'Shuttle Pickup Point'
  , '接驳下车点': 'Shuttle Drop-Off Point'
  , '接驳任务': 'Shuttle Task'
  , '接驳任务已完成。': 'Shuttle task completed.'
  , '接驳已完成': 'Shuttle Completed'
  , '接驳服务已开始，机器人正在前往终点。': 'Shuttle service started. The robot is heading to the destination.'
  , '接驳服务进行中，到达终点后请申请结束。': 'Shuttle service is active. Request completion at the destination.'
  , '接驳服务进行中，机器人正在前往接驳终点。': 'Shuttle service is active. The robot is heading to the destination.'
  , '接驳起点': 'Shuttle Start Point'
  , '提交复核': 'Submit Review'
  , '提交异常复核': 'Submit Exception Review'
  , '暂无任务描述': 'No Task Description'
  , '暂无可信执行数据。': 'No trusted execution data.'
  , '暂无心跳时间': 'No Heartbeat Time'
  , '暂未收到 SDK 心跳。': 'No SDK heartbeat received yet.'
  , '暂未收到 SDK 心跳，出发/开始/结束节点可能无法完成 TPM 验签。': 'No SDK heartbeat received. TPM verification may fail for departure, start, or completion.'
  , '服务中车辆速度接近 0，请关注是否停滞、异常等待或需要人工介入。': 'Vehicle speed is near zero during service. Check for a stall or need for intervention.'
  , '服务开始前不会计费，避免提前扣币。': 'Billing does not start before service begins.'
  , '服务开始后会记录时间。': 'Time is recorded after service starts.'
  , '服务正在计时，用户确认结束后结算。': 'Service timing is active. Settlement follows user confirmation.'
  , '服务正在进行中，等待服务者申请结束。': 'Service is active. Waiting for the provider to request completion.'
  , '服务者主要负责推进机器人出发、到达、申请开始和申请结束。需要验签的节点会先经过 SDK/TPM。': 'Providers advance departure, arrival, start, and completion. Trusted actions require SDK/TPM verification.'
  , '服务者已接单，等待机器人出发。': 'Provider accepted. Waiting for robot departure.'
  , '服务者已接单，等待机器人出发前往接驳起点。': 'Provider accepted. Waiting for departure to the shuttle start point.'
  , '服务者已申请开始接驳，请确认乘客已上车并开始计时。': 'The provider requested shuttle start. Confirm boarding to begin timing.'
  , '服务者已申请开始服务，请确认是否开始计时。': 'The provider requested service start. Confirm to begin timing.'
  , '服务者已申请开始，发布者确认后才会正式开始计费。': 'The provider requested start. Billing begins after publisher confirmation.'
  , '服务者已申请结束接驳，请确认已到达终点并完成结算。': 'The provider requested shuttle completion. Confirm arrival and settlement.'
  , '服务者已申请结束服务，请确认服务结束并完成结算。': 'The provider requested completion. Confirm the result and settlement.'
  , '服务者已申请结束，但发布者未确认前计时不会停止。': 'The provider requested completion, but timing continues until publisher confirmation.'
  , '服务者已申请结束，用户确认结束前仍继续计时。': 'The provider requested completion. Timing continues until user confirmation.'
  , '服务者已申请结束，请确认现场结果并完成结算。': 'The provider requested completion. Confirm the result and settlement.'
  , '服务者申请开始': 'Provider Requested Start'
  , '服务者申请开始，发布者确认后才进入正式计时。': 'The provider requested start. Timing begins after publisher confirmation.'
  , '服务者申请结束': 'Provider Requested Completion'
  , '服务者申请结束，等待发布者确认服务结果。': 'The provider requested completion. Waiting for publisher confirmation.'
  , '服务者申请结束，表示车辆已到达接驳终点或等待发布者确认。': 'The provider requested completion after reaching the shuttle destination.'
  , '服务进行中，完成后请申请结束。': 'Service is active. Request completion when finished.'
  , '未出发前不扣费': 'No Charge Before Departure'
  , '未知类型': 'Unknown Type'
  , '未触发': 'Not Triggered'
  , '机器人SDK验证': 'Robot SDK Verification'
  , '机器人从起点到终点执行接驳': 'The robot provides shuttle service between the route points'
  , '机器人到指定地点完成服务': 'The robot completes service at the specified location'
  , '机器人已出发': 'Robot Departed'
  , '机器人已出发，到达服务点后请确认到达。': 'The robot departed. Confirm arrival at the service point.'
  , '机器人已出发，正在前往接驳起点。': 'The robot departed for the shuttle start point.'
  , '机器人已到达': 'Robot Arrived'
  , '机器人已到达接驳起点，等待服务者申请开始或乘客确认上车。': 'The robot reached the shuttle start point. Waiting for start or boarding confirmation.'
  , '机器人已到达接驳起点，请在乘客准备好后申请开始服务。': 'The robot reached the shuttle start point. Request service start when the passenger is ready.'
  , '机器人已到达接驳起点，请申请开始接驳。': 'The robot reached the shuttle start point. Request shuttle start.'
  , '机器人已到达服务地址，等待服务者申请开始。': 'The robot reached the service address. Waiting for the provider to request start.'
  , '机器人已到达服务地址，请申请开始服务。': 'The robot reached the service address. Request service start.'
  , '机器人已到达，请申请开始服务。': 'The robot arrived. Request service start.'
  , '机器人已接单': 'Robot Accepted the Task'
  , '机器人正在前往接驳起点，你可以在地图上查看车辆位置。': 'The robot is heading to the shuttle start point. Track it on the map.'
  , '机器人正在前往接驳起点，到达后请确认已到达。': 'The robot is heading to the shuttle start point. Confirm arrival there.'
  , '机器人正在前往服务地址，你可以在地图上查看车辆位置。': 'The robot is heading to the service address. Track it on the map.'
  , '机器人正在前往服务地址，到达后请确认已到达。': 'The robot is heading to the service address. Confirm arrival there.'
  , '查看订单当前阶段和相关服务信息。': 'View the current order stage and service details.'
  , '查看重启 Agent 命令': 'View Agent Restart Command'
  , '核验并接管': 'Verify and Take Over'
  , '正在同步订单状态...': 'Syncing Order Status...'
  , '正在建立验证': 'Creating Verification'
  , '正在等待SDK上报，或后端暂时不可达。': 'Waiting for the SDK report, or the backend is temporarily unavailable.'
  , '流程日志等待同步。': 'Waiting for workflow log sync.'
  , '用户主动取消任务': 'User Cancelled the Task'
  , '用户确认开始': 'User Confirmed Start'
  , '用户确认开始后才会正式计时。': 'Timing begins after user confirmation.'
  , '用户确认结束': 'User Confirmed Completion'
  , '申请开始服务': 'Request Service Start'
  , '申请结束服务': 'Request Service Completion'
  , '相关方': 'Related Party'
  , '知道了': 'Got It'
  , '确认开始服务': 'Confirm Service Start'
  , '确认接管': 'Confirm Takeover'
  , '确认是否接受第二段协作': 'Confirm Stage 2 Collaboration'
  , '确认服务结束并结算': 'Confirm Completion and Settle'
  , '确认机器人已出发': 'Confirm Robot Departure'
  , '确认机器人已到达': 'Confirm Robot Arrival'
  , '第一段已到达，等待交接核验': 'Stage 1 Arrived; Waiting for Handoff Verification'
  , '第一段已发起交接，请现场取得交接码并完成身份核验。': 'Stage 1 started the handoff. Get the code on site and verify identity.'
  , '第一段：车辆前往上车点': 'Stage 1: Vehicle to Pickup Point'
  , '第二段：车辆前往下车点': 'Stage 2: Vehicle to Drop-Off Point'
  , '等待 DeRAS 订单中心同步。': 'Waiting for DeRAS Order Center sync.'
  , '等待 SDK 心跳': 'Waiting for SDK Heartbeat'
  , '等待GPS': 'Waiting for GPS'
  , '等待SDK上报': 'Waiting for SDK Report'
  , '等待SDK验证通过': 'Waiting for SDK Verification'
  , '等待上车确认': 'Waiting for Boarding Confirmation'
  , '等待乘客上车/确认开始': 'Waiting for Boarding / Start Confirmation'
  , '等待任务发布者确认开始，确认后才会正式计时。': 'Waiting for the publisher to confirm start before timing begins.'
  , '等待任务发布者确认结束，系统会按实际服务时长结算。': 'Waiting for publisher completion confirmation and duration-based settlement.'
  , '等待发布者确认': 'Waiting for Publisher Confirmation'
  , '等待地图坐标': 'Waiting for Map Coordinates'
  , '等待坐标': 'Waiting for Coordinates'
  , '等待工控机SDK上报。': 'Waiting for the controller SDK report.'
  , '等待工控机上的 SDK Agent 拉取挑战并调用TPM签名。': 'Waiting for the controller SDK Agent to fetch and sign the challenge with TPM.'
  , '等待开始': 'Waiting to Start'
  , '等待接单方确认机器人状态。': 'Waiting for the provider to confirm robot status.'
  , '等待接驳路线同步。': 'Waiting for shuttle route sync.'
  , '等待方案状态': 'Waiting for Plan Status'
  , '等待服务者推进': 'Waiting for Provider Action'
  , '等待现场交接码': 'Waiting for On-Site Handoff Code'
  , '等待生成': 'Waiting for Generation'
  , '等待用户确认开始': 'Waiting for User Start Confirmation'
  , '等待用户确认结束': 'Waiting for User Completion Confirmation'
  , '等待申请': 'Waiting for Request'
  , '等待第二段机器人确认': 'Waiting for Stage 2 Robot Confirmation'
  , '等待结束': 'Waiting for Completion'
  , '等待订单': 'Waiting for Order'
  , '等待订单同步': 'Waiting for Order Sync'
  , '等待订单状态同步。': 'Waiting for order status sync.'
  , '等待证据': 'Waiting for Evidence'
  , '等待车辆 GPS': 'Waiting for Vehicle GPS'
  , '等待验证': 'Waiting for Verification'
  , '终点：未填写': 'Destination: Not Provided'
  , '结束服务': 'Complete Service'
  , '联系服务者处理': 'Contact Provider'
  , '计时中': 'Timing Active'
  , '计时已停止，最终结算按后端记录的开始和结束时间计算。': 'Timing stopped. Final settlement uses the recorded start and end times.'
  , '订单已结束，后端未返回详细结算说明。': 'The order ended without detailed settlement information.'
  , '订单已进入 DeRAS 履约流程，服务机器人被锁定到该任务。': 'The order entered DeRAS execution and the service robot is locked to it.'
  , '订单状态同步失败': 'Failed to Sync Order Status'
  , '请先完成机器人SDK绑定后再启动 Agent': 'Complete robot SDK binding before starting the Agent'
  , '请先核对第二段机器人、交接点和分账比例，再决定是否接受协作。': 'Review the stage 2 robot, handoff point, and revenue split before accepting.'
  , '请填写取消原因': 'Enter a cancellation reason'
  , '请填写复核说明': 'Enter review details'
  , '请安排机器人出发前往服务地址。': 'Send the robot to the service address.'
  , '请安排机器人出发，第一段目的地是接驳起点。': 'Send the robot to the shuttle start point for stage 1.'
  , '请根据当前阶段推进任务。': 'Advance the task according to its current stage.'
  , '请确认服务结果，确认后 DeRAS 会生成最终结算凭证。': 'Confirm the service result so DeRAS can create the final receipt.'
  , '请确认现场条件是否满足，确认后才开始计时和后续 RoboCoin 结算。': 'Confirm on-site conditions before timing and RoboCoin settlement begin.'
  , '请简单说明为什么需要 DeRAS 复核，后续会进入履约日志和消息中心。': 'Briefly explain why DeRAS review is needed. It will appear in logs and messages.'
  , '请输入 2 至 255 个字符': 'Enter 2-255 characters'
  , '请输入第一段机器人现场提供的交接码。': 'Enter the handoff code provided by the stage 1 robot.'
  , '车辆': 'Vehicle'
  , '车辆 GPS 位置': 'Vehicle GPS Location'
  , '车辆到达接驳起点，等待上车和开始服务确认。': 'Vehicle reached the shuttle start point. Waiting for boarding and start confirmation.'
  , '车辆到达服务地址，等待开始服务确认。': 'Vehicle reached the service address. Waiting for start confirmation.'
  , '车辆处于出发阶段但速度接近 0，请关注是否堵车、等待或车辆未实际移动。': 'Vehicle speed is near zero after departure. Check for traffic, waiting, or no movement.'
  , '车辆长时间不动风险': 'Vehicle Stoppage Risk'
  , '车辆长时间不动，需要 DeRAS 复核履约状态。': 'The vehicle has not moved for a long time. DeRAS review is required.'
  , '需补扣': 'Additional Charge Due'
  , '验证未通过': 'Verification Failed'
  , '选择起点和终点后计算': 'Calculated After Selecting Both Route Points'
  , '预估接口未返回有效结果，当前使用默认预估。': 'Estimate service returned no valid result. Default estimate is in use.'
  , '预估读取失败，当前使用默认预估。': 'Failed to load estimate. Default estimate is in use.'
  , '请先登录正式账户，再发布任务。': 'Sign in to a full account before publishing a task.'
  , '任务发布失败，请检查任务信息后重试。': 'Task publishing failed. Check the details and try again.'
  , '任务发布失败，请稍后重试。': 'Task publishing failed. Try again later.'
  , '个人资料加载失败': 'Failed to Load Profile'
  , '订单加载失败': 'Failed to Load Orders'
  , '订单请求失败': 'Order Request Failed'
  , '已发布任务加载失败': 'Failed to Load Published Tasks'
  , '已发布任务请求失败': 'Published Task Request Failed'
  , '复核/仲裁记录加载失败': 'Failed to Load Review and Arbitration Records'
  , '复核/仲裁记录请求失败': 'Review and Arbitration Request Failed'
  , '机器人钱包加载失败': 'Failed to Load Robot Wallets'
  , '资料保存失败': 'Failed to Save Profile'
  , '个人资料已保存': 'Profile Saved'
  , '资料保存请求失败': 'Profile Save Request Failed'
  , '两次输入的新密码不一致': 'The New Passwords Do Not Match'
  , '密码修改失败': 'Failed to Change Password'
  , '密码已修改': 'Password Changed'
  , '密码修改请求失败': 'Password Change Request Failed'
  , '请选择图片文件': 'Choose an Image File'
  , '协作方案已生效，可以开始履约': 'Collaboration Activated; Execution Can Start'
  , '拒绝后整份分包方案会取消，原任务将重新开放派单。请输入原因。': 'Rejecting cancels the subcontracting plan and reopens dispatch. Enter a reason.'
  , '履约日志加载失败': 'Failed to Load Execution Logs'
  , '履约日志请求失败': 'Execution Log Request Failed'
  , '进行中的订单不能删除，请先处理完成或取消': 'Active orders cannot be deleted. Complete or cancel the order first.'
  , '确认从个人中心删除这条订单记录吗？平台后台和财务审计记录会继续保留。': 'Delete this order from your profile? Platform and financial audit records will remain.'
  , '删除订单': 'Delete Order'
  , '订单删除失败': 'Failed to Delete Order'
  , '订单已从个人中心删除': 'Order Removed from Profile'
  , '重新发布后，任务会恢复并再次进入 DeRAS 审核与派单流程。': 'Republishing restores the task and sends it through DeRAS review and dispatch again.'
  , '任务重新发布失败': 'Failed to Republish Task'
  , '任务已重新发布并进入审核队列': 'Task Republished and Added to the Review Queue'
  , '该操作会从已发布任务列表中永久删除这条已取消任务。': 'This permanently removes the cancelled task from the published task list.'
  , '任务删除失败': 'Failed to Delete Task'
  , '任务已删除': 'Task Deleted'
  , '确认取消这个任务发布吗？如果已经生成订单，系统会同步取消订单并释放机器人。': 'Cancel this published task? Any linked order will also be cancelled and its robot released.'
  , '先不取消': 'Keep Task'
  , '机器人档案加载失败': 'Failed to Load Robot Profile'
  , '机器人档案加载失败，请稍后重试。': 'Failed to load the robot profile. Try again later.'
  , '机器人名称不能为空': 'Robot Name Is Required'
  , '投入使用日期不能早于生产日期': 'Commission Date Cannot Precede Manufacture Date'
  , '档案保存失败': 'Failed to Save Robot Profile'
  , '机器人档案已更新': 'Robot Profile Updated'
  , '档案保存失败，请稍后重试。': 'Failed to save the robot profile. Try again later.'
  , '机器人市场仅管理员可见': 'Robot Market Is Available to Administrators Only'
  , '机器人市场加载失败': 'Failed to Load Robot Market'
  , '机器人市场请求失败，请检查后端服务': 'Robot market request failed. Check the backend service.'
  , '下架后该机器人会从已通过列表移除，确定继续吗？': 'Removing this robot takes it out of the approved list. Continue?'
  , '下架机器人': 'Remove Robot'
  , '确定下架': 'Confirm Removal'
  , '操作失败，请稍后重试': 'Operation failed. Try again later.'
  , '当前无法连接登录接口，请稍后重试。': 'Cannot reach the sign-in service. Try again later.'
  , '当前无法连接注册接口，请稍后重试。': 'Cannot reach the registration service. Try again later.'
  , '任务数据读取失败。': 'Failed to Load Task Data.'
  , '机器人数据读取失败。': 'Failed to Load Robot Data.'
  , '请检查网络': 'Check the Network'
  , '请检查 Key 或网络': 'Check the API Key or Network'
  , '查看已通过任务，先确认详情和距离，再决定是否接单。': 'Review approved tasks, check the details and distance, then decide whether to accept.'
  , 'DeRAS会先自动校验上门服务任务，管理员保留人工复核与兜底通过。': 'DeRAS automatically validates on-site tasks; administrators retain manual review and fallback approval.'
  , '服务暂时不可用，请稍后重试。': 'Service is temporarily unavailable. Try again later.'
  , '请求失败，请稍后重试。': 'Request failed. Try again later.'
  , '请求已取消。': 'Request Cancelled.'
  , '任务审核后台': 'Task Review Console'
  , '保存中...': 'Saving...'
  , '保存设置': 'Save Settings'
  , '未命名任务': 'Unnamed Task'
  , '未填写电话': 'No Phone Provided'
  , '暂无说明': 'No Details'
  , '暂无候选队列记录': 'No Candidate Queue Records'
  , 'DeRAS仍在正常寻找候选机器人。': 'DeRAS Is Still Searching for Candidate Robots.'
  , '第一段机器人': 'Stage 1 Robot'
  , '执行机器人': 'Execution Robot'
  , '暂无候选队列': 'No Candidate Queue'
  , 'DeRAS审批中...': 'DeRAS Review in Progress...'
  , 'DeRAS验证中...': 'DeRAS Verification in Progress...'
  , '红色预警': 'Critical Alert'
  , '黄色提醒': 'Warning'
  , '未知用户': 'Unknown User'
  , '未填写联系方式': 'No Contact Information'
  , '暂无机器人能力描述': 'No Robot Capability Description'
  , '尚未结束': 'Not Completed'
  , '提交仲裁中...': 'Submitting Arbitration...'
  , '正在取消...': 'Cancelling...'
  , 'SDK Agent备用启动命令已复制': 'SDK Agent Fallback Start Command Copied'
  , '未知服务者': 'Unknown Provider'
  , '暂无机器人能力描述。': 'No robot capability description.'
  , '提交中...': 'Submitting...'
  , '拒绝并进入仲裁': 'Reject and Start Arbitration'
  , '自动派单': 'Automatic Dispatch'
  , '等待扫描': 'Waiting for Scan'
  , 'DeRAS正在同步派单事件。': 'DeRAS Is Syncing Dispatch Events.'
  , '暂无推荐说明': 'No Recommendation Details'
  , '类型匹配、SDK在线、机器人空闲、接单开关开启。': 'Type Matched; SDK Online; Robot Available; Task Acceptance Enabled.'
  , '处理中...': 'Processing...'
  , '清空中...': 'Clearing...'
  , '邀请已超时': 'Invitation Expired'
  , '类型匹配、SDK在线、机器人空闲、信誉分达标。': 'Type Matched; SDK Online; Robot Available; Reputation Passed.'
  , '关联任务': 'Related Task'
  , '接受任务': 'Accept Task'
  , '删除中...': 'Deleting...'
  , '已接单和服务历史': 'Accepted Task and Service History'
  , '我创建的任务需求': 'Tasks I Published'
  , '异常与处理结果': 'Exceptions and Resolutions'
  , 'RoboCoin余额': 'RoboCoin Balance'
  , '头像、姓名、联系方式': 'Avatar, Name, and Contact'
  , '修改登录密码': 'Change Sign-In Password'
  , '凭证编号已复制': 'Receipt ID Copied'
  , '暂无': 'None'
  , '凭证信息已复制': 'Receipt Details Copied'
  , '复核信息已复制': 'Review Details Copied'
  , '未填写起点': 'Start Point Not Provided'
  , '未填写终点': 'Destination Not Provided'
  , '未填写服务地点': 'Service Location Not Provided'
  , '未知服务': 'Unknown Service'
  , '相关订单': 'Related Order'
  , '等待交接核验': 'Waiting for Handoff Verification'
  , '未生成': 'Not Generated'
  , '已生成结算凭证': 'Settlement Receipt Created'
  , '取消凭证': 'Cancellation Receipt'
  , '仲裁冻结中': 'Frozen for Arbitration'
  , '服务处理中': 'Service in Progress'
  , '暂无复核': 'No Review'
  , '订单仲裁中': 'Order in Arbitration'
  , '复核中': 'Under Review'
  , '未记录': 'Not Recorded'
  , 'TPM签名': 'TPM Signature'
  , 'GPS定位': 'GPS Location'
  , '用户确认': 'User Confirmation'
  , 'DeRAS审计': 'DeRAS Audit'
  , '结算凭证': 'Settlement Receipt'
  , 'PoT链下证明': 'Off-Chain PoT Proof'
  , 'TPM签名 + PoT证明': 'TPM Signature + PoT Proof'
  , '失败': 'Failed'
  , 'SDK验签': 'SDK Signature Verification'
  , 'SDK心跳': 'SDK Heartbeat'
  , 'PoT证明': 'PoT Proof'
  , '未完成计时': 'Timing Incomplete'
  , '未填写钱包地址': 'Wallet Address Not Provided'
  , 'SDK已确认': 'SDK Confirmed'
  , 'SDK待确认': 'SDK Confirmation Pending'
  , '待注册': 'Pending Registration'
  , 'RoboCoin 用户': 'RoboCoin User'
  , '未绑定邮箱': 'Email Not Linked'
  , '待补充': 'To Be Added'
  , '删除中': 'Deleting'
  , '取消中': 'Cancelling'
  , '复核/仲裁记录': 'Review / Arbitration Records'
  , '暂无处理说明。': 'No processing details.'
  , '不限制': 'No Restriction'
  , '保存资料': 'Save Profile'
  , '修改中...': 'Updating...'
  , '修改密码': 'Change Password'
  , '订单结算凭证': 'Order Settlement Receipt'
  , '暂无详细结算说明。': 'No detailed settlement information.'
  , '暂无裁决说明。': 'No decision details.'
  , '制造商、型号和序列号待补充': 'Manufacturer, Model, and Serial Number Pending'
  , '暂无心跳记录': 'No Heartbeat Records'
  , '已认证': 'Verified'
  , '待认证': 'Pending Verification'
  , '已注销': 'Deactivated'
  , '配送': 'Delivery'
  , '巡检': 'Inspection'
  , '巡逻': 'Patrol'
  , '通用任务': 'General Task'
  , '执行中': 'In Progress'
  , '未记录地点': 'Location Not Recorded'
  , '未登记': 'Not Registered'
  , '保存中': 'Saving'
  , '保存': 'Save'
  , '服务区域未登记': 'Service Region Not Registered'
  , '当前开放接单': 'Currently Accepting Tasks'
  , '当前暂停接单': 'Task Acceptance Currently Paused'
  , '未限制服务区域': 'No Service Region Restriction'
  , 'SDK Agent 正常在线': 'SDK Agent Online'
  , 'SDK Agent 当前离线': 'SDK Agent Offline'
  , '未上报': 'Not Reported'
  , '已检测': 'Detected'
  , '未检测': 'Not Detected'
  , '暂无能力说明。': 'No capability details.'
  , '暂无档案备注。': 'No profile notes.'
  , '机器人已下架': 'Robot Removed'
  , '按状态、类型和服务区域查看已注册机器人；管理员可对已通过机器人执行下架。': 'View registered robots by status, type, and region. Administrators can remove approved robots.'
  , '返回控制台入口': 'Back to Console'
  , '机器人状态筛选': 'Filter by Robot Status'
  , '按服务区域筛选': 'Filter by Service Region'
  , '未命名机器人': 'Unnamed Robot'
  , '暂无能力描述': 'No Capability Description'
  , '联系电话：': 'Contact Phone:'
  , '评分：': 'Score:'
  , '余额：': 'Balance:'
  , '暂无机器人': 'No Robots'
  , '早上好': 'Good Morning'
  , '下午好': 'Good Afternoon'
  , '晚上好': 'Good Evening'
  , '机': 'BOT'
  , '任': 'TASK'
  , '地点待确认': 'Location Pending'
  , '请输入邮箱或国际手机号。': 'Enter your email or international phone number.'
  , '请输入密码。': 'Enter your password.'
  , '请填写邮箱或手机号。': 'Enter an email address or phone number.'
  , '请输入正确的国际区号。': 'Enter a valid international country code.'
  , '密码至少需要 8 位。': 'Password must be at least 8 characters.'
  , '两次输入的密码不一致。': 'The passwords do not match.'
  , '账号或密码不正确。': 'Incorrect account or password.'
  , '账户创建失败，请检查填写内容。': 'Account creation failed. Check the information and try again.'
  , '登录接口未返回有效凭证。': 'The sign-in service did not return valid credentials.'
  , '登录接口未返回用户 ID，无法读取账户任务。': 'The sign-in service did not return a user ID, so account tasks cannot be loaded.'
  , '已连接 DeRAS 任务网络。': 'Connected to the DeRAS task network.'
  , '待验证': 'Pending Verification'
  , '等待接单': 'Waiting for Acceptance'
  , '已发布': 'Published'
  , '时间待同步': 'Time Pending Sync'
  , 'SDK 在线': 'SDK Online'
  , 'SDK 离线': 'SDK Offline'
  , '开放接单': 'Accepting Tasks'
  , '暂未填写能力描述。': 'No capability description provided.'
  , '正在读取设备': 'Loading Devices'
  , '账户下暂无机器人': 'No Robots in This Account'
  , '预览模式不读取真实账户数据。': 'Preview mode does not load live account data.'
  , '请在电脑端完成机器人注册和 SDK 绑定。': 'Complete robot registration and SDK binding on the desktop site.'
  , '已连接正式账户': 'Live Account Connected'
  , '未绑定': 'Not Linked'
  , '退出预览': 'Exit Preview'
  , '登录后发布': 'Sign In to Publish'
  , '已在地图上确认位置': 'Location Confirmed on Map'
  , '轮': 'WHEEL'
  , '狗': 'DOG'
  , '<机器人ID>': '<ROBOT_ID>'
  , '<用户ID>': '<USER_ID>'
  , '<SDK绑定令牌>': '<SDK_BINDING_TOKEN>'
  , '接驳起点待选择': 'Select a Shuttle Start Point'
  , '接驳终点待选择': 'Select a Shuttle Destination'
  , '服务地址待选择': 'Select a Service Address'
  , '距接驳起点': 'Distance to Pickup'
  , '距接驳终点': 'Distance to Drop-Off'
  , '道路剩余距离': 'Remaining Road Distance'
  , '直线距离': 'Straight-Line Distance'
  , '等待GPS': 'Waiting for GPS'
  , '等待 OK': 'Waiting for OK'
  , '正在规划接驳第二段路线：从起点前往终点。': 'Planning the second shuttle leg from the pickup point to the destination.'
  , '正在规划路线，车辆会从当前 GPS 坐标出发。': 'Planning a route from the vehicle\'s current GPS location.'
  , '车辆已到达接驳起点。这里模拟乘客上车确认，点击地图里的 OK 后再前往终点。': 'The vehicle reached the pickup point. Confirm boarding on the map to continue to the destination.'
  , '接驳测试中：车辆正在从当前位置前往用户起点。': 'Shuttle test in progress: the vehicle is heading to the pickup point.'
  , '接驳测试中：车辆正在从起点前往终点。': 'Shuttle test in progress: the vehicle is heading to the destination.'
  , '测试执行已完成。刷新页面后会重新读取车辆最新 GPS 经纬度。': 'The test is complete. Refresh the page to load the latest vehicle GPS coordinates.'
  , '正在规划道路路线，用于展示更接近真实行驶距离的 ETA。': 'Planning a road route for a more accurate travel distance and ETA.'
  , '已按道路路线计算：车辆正在前往接驳起点。': 'Road route calculated: the vehicle is heading to the pickup point.'
  , '已按道路路线计算：车辆正在前往接驳终点。': 'Road route calculated: the vehicle is heading to the destination.'
  , '已按道路路线计算车辆到服务点的距离和预计到达时间。': 'Road distance and ETA to the service point have been calculated.'
  , '模拟坐标': 'Simulated Location'
  , '待出发': 'Ready to Depart'
  , '前往服务点': 'Heading to Service Point'
  , '已到达': 'Arrived'
  , '服务中': 'In Service'
  , '获取路线中...': 'Loading Route...'
  , '前往起点中': 'Heading to Pickup'
  , '前往终点中': 'Heading to Destination'
  , '等待起点确认': 'Waiting for Pickup Confirmation'
  , '重新测试执行': 'Run Test Again'
  , '测试执行': 'Run Test'
  , '正在规划真实道路路线': 'Planning Road Route'
  , '已到达接驳起点，等待 OK': 'At Pickup Point, Waiting for OK'
  , '接驳第一段：车辆前往起点': 'Shuttle Leg 1: Vehicle to Pickup'
  , '接驳第二段：车辆前往终点': 'Shuttle Leg 2: Vehicle to Destination'
  , '测试路线已完成': 'Test Route Complete'
  , '道路路线暂不可用': 'Road Route Unavailable'
  , '真实道路路线服务暂不可用。': 'The road routing service is temporarily unavailable.'
  , '接驳起点 · 等待 OK': 'Pickup Point · Waiting for OK'
  , '测试路线 · 演示中': 'Test Route · Running'
  , '测试路线 · 已完成': 'Test Route · Complete'
  , ' · 非实时': ' · Not Live'
  , ' · 实时': ' · Live'
  , '· 非实时': '· Not Live'
  , '· 实时': '· Live'
  , '贵州省博物馆': 'Guizhou Provincial Museum'
  , '确认后两台机器人、交接点和分账比例都不能中途修改。': 'After confirmation, the two robots, handoff point, and revenue split cannot be changed.'
}

const reverseTranslations = {
  ...Object.fromEntries(Object.entries(translations).map(([zh, en]) => [en, zh])),
  'UI Preview': '界面预览',
  'Preview User': '预览用户'
}

export const localeState = Object.freeze({ locale: 'en' })

function translateDynamic(value, targetLocale) {
  if (targetLocale === 'en') {
    const known = text => translations[text] || text
    return value
      .replace(/^还有 (\d+) 条未读消息$/, '$1 unread messages')
      .replace(/^共 (\d+) 条$/, '$1 total')
      .replace(/^(\d+) 台设备$/, '$1 devices')
      .replace(/^(\d+) 条任务$/, '$1 tasks')
      .replace(/^(\d+)秒$/, '$1 seconds')
      .replace(/^(\d+)分钟$/, '$1 minutes')
      .replace(/^(\d+)小时$/, '$1 hours')
      .replace(/^(\d+) 秒$/, '$1 seconds')
      .replace(/^(\d+) 分钟$/, '$1 minutes')
      .replace(/^(\d+) 小时$/, '$1 hours')
      .replace(/^(\d+) 小时 (\d+) 分钟$/, '$1 hr $2 min')
      .replace(/^(\d+) 小时 (\d+) 分$/, '$1 hr $2 min')
      .replace(/^(\d+(?:\.\d+)?) 米$/, '$1 m')
      .replace(/^(\d+(?:\.\d+)?) 公里$/, '$1 km')
      .replace(/^约 (\d+) 分钟$/, 'About $1 min')
      .replace(/^约 (\d+) 小时$/, 'About $1 hr')
      .replace(/^约 (\d+) 小时 (\d+) 分钟$/, 'About $1 hr $2 min')
      .replace(/^(\d+)秒前心跳$/, 'Heartbeat $1 sec ago')
      .replace(/^(\d+)分钟前心跳$/, 'Heartbeat $1 min ago')
      .replace(/^(\d+) 秒前收到心跳$/, 'Heartbeat received $1 sec ago')
      .replace(/^(\d+) 分钟前收到心跳$/, 'Heartbeat received $1 min ago')
      .replace(/^(\d+) 小时前收到心跳$/, 'Heartbeat received $1 hr ago')
      .replace(/^任务 #(.*)$/, 'Task #$1')
      .replace(/^订单 #(.*)$/, 'Order #$1')
      .replace(/^机器人 #(.*)$/, 'Robot #$1')
      .replace(/^用户#(.*)$/, 'User #$1')
      .replace(/^公钥指纹：(.*)$/, 'Public Key Fingerprint: $1')
      .replace(/^当前按约 (.+)、(.+) 预估；距离单价 (.+) RoboCoin\/公里，时间单价 (.+) RoboCoin\/小时。$/, 'Estimated from $1 and $2; distance rate $3 RoboCoin/km, time rate $4 RoboCoin/hr.')
      .replace(/^(.+)：约 (.+)，当前阶段由平台按 (.+) RoboCoin\/小时提供任务补助。$/, 'Estimated duration: $2. Current platform subsidy rate: $3 RoboCoin/hr.')
      .replace(/^平台补助已记录：(.+) RoboCoin$/, 'Platform subsidy recorded: $1 RoboCoin')
      .replace(/^正在记录平台补助 (.+) RoboCoin 并写入任务信息，请稍候。$/, 'Recording a $1 RoboCoin subsidy and saving the task. Please wait.')
      .replace(/^机器人「(.+)」已锁定任务$/, 'Robot "$1" locked the task')
      .replace(/^已并发邀请候选机器人，最新候选为 (.+)$/, 'Candidate robots invited; latest candidate: $1')
      .replace(/^(.+) 至 (.+) 的交接点$/, 'Handoff point between $1 and $2')
      .replace(/^(.+)交接点$/, '$1 handoff point')
      .replace(/^(.+) · 评分 (.+?)( · 我的设备)?$/, (_, name, score, owned) => `${name} · Score ${score}${owned ? ' · My Device' : ''}`)
      .replace(/^DeRAS已连续 (\d+) 轮未找到可用候选，建议检查是否有同类型机器人在线、是否开启接单、SDK Agent是否在线。$/, 'DeRAS found no candidate in $1 rounds. Check matching robots, task acceptance, and SDK Agent status.')
      .replace(/^机器人「(.+)」已锁定该任务$/, 'Robot "$1" locked this task')
      .replace(/^已并发邀请候选机器人，当前最新候选为 (.+)，谁先确认谁锁定任务$/, 'Candidates invited; latest: $1. The first confirmation locks the task.')
      .replace(/^已扫描 (\d+) 轮，DeRAS会继续寻找在线、空闲、类型匹配的机器人$/, '$1 scan rounds completed. DeRAS will keep finding available matching robots.')
      .replace(/^自动派单暂未找到候选，已于 (.+) 开放给服务者抢单$/, 'No automatic dispatch candidate found. Open to providers since $1.')
      .replace(/^地址搜索服务加载失败：(.+)$/, 'Failed to load the address search service: $1')
      .replace(/^地图服务初始化失败：(.+)$/, 'Failed to initialize the map service: $1')
      .replace(/^地图搜索未返回结果：(.+)$/, 'Map search returned no results: $1')
      .replace(/^候选地点 (\d+)$/, 'Candidate Location $1')
      .replace(/^演示约 (\d+) 秒$/, 'Demo: about $1 sec')
      .replace(/^演示约 (\d+) 分钟$/, 'Demo: about $1 min')
      .replace(/^(.+) 当前使用直线演示路线。$/, '$1 Using a straight-line demo route.')
      .replace(/^已接入 TDengine GPS 原始坐标：(.+)。当前地图按 WGS84 展示，不做高德\/腾讯坐标纠偏。$/, 'Using raw TDengine GPS coordinates from $1. The map displays WGS84 coordinates without AMap/Tencent conversion.')
      .replace(/^暂未收到车辆GPS，先用(.+)作为模拟起点展示。$/, (_, place) => `No vehicle GPS received. Using ${known(place)} as the simulated starting point.`)
      .replace(/^(.+) · 非实时$/, '$1 · Not Live')
      .replace(/^(.+) · 实时$/, '$1 · Live')
      .replace(/^车辆可能偏离当前道路路线约 (.+) 米，请关注现场运行状态$/, 'The vehicle may be about $1 m off the current road route. Monitor on-site operation.')
      .replace(/^凭证编号：(.+)$/, 'Receipt ID: $1')
      .replace(/^订单：#(.+?)(?: (.*))?$/, (_, id, title) => `Order: #${id}${title ? ` ${title}` : ''}`)
      .replace(/^服务类型：(.+)$/, (_, label) => `Service Type: ${known(label)}`)
      .replace(/^状态：(.+)$/, (_, label) => `Status: ${known(label)}`)
      .replace(/^平台补助：(.+) ROC$/, 'Platform Subsidy: $1 ROC')
      .replace(/^最终应付：(.+) ROC$/, 'Final Amount: $1 ROC')
      .replace(/^平台手续费：(.+) ROC$/, 'Platform Fee: $1 ROC')
      .replace(/^服务方收入：(.+) ROC$/, 'Provider Income: $1 ROC')
      .replace(/^服务时长：(.+)$/, (_, duration) => `Service Duration: ${known(duration)}`)
      .replace(/^复核\/仲裁：(.+)$/, (_, label) => `Review / Arbitration: ${known(label)}`)
      .replace(/^可信证据：(.+)$/, 'Trusted Evidence: $1')
      .replace(/^复核记录：#(.+)$/, 'Review Record: #$1')
      .replace(/^任务：(.+)$/, 'Task: $1')
      .replace(/^我的身份：(.+)$/, (_, label) => `My Role: ${known(label)}`)
      .replace(/^事件类型：(.+)$/, (_, label) => `Event Type: ${known(label)}`)
      .replace(/^处理状态：(.+)$/, (_, label) => `Processing Status: ${known(label)}`)
      .replace(/^事件说明：(.+)$/, 'Event Details: $1')
      .replace(/^裁决结果：(.+)$/, 'Decision: $1')
      .replace(/^证据摘要：(.+)$/, 'Evidence Summary: $1')
      .replace(/^最近心跳 (.+)$/, 'Latest Heartbeat $1')
      .replace(/^剩余 (.+)$/, 'Remaining $1')
      .replace(/^确认机器人「(.+)」当前绑定的TPM设备就是你的设备吗？确认后后续派单会用这个公钥做DeRAS验签。$/, 'Confirm that the TPM device currently bound to robot "$1" belongs to you. Its public key will be used to verify future DeRAS dispatches.')
      .replace(/^验证：(.+)$/, (_, stage) => `Verification: ${known(stage)}`)
      .replace(/^确认(.+)$/, (_, stage) => `Confirm ${known(stage)}`)
      .replace(/^已确认：(.+)$/, (_, stage) => `Confirmed: ${known(stage)}`)
      .replace(/^正在建立(.+)验证，但机器人 SDK Agent 当前离线：(.+)$/, (_, action, reason) => `Creating ${known(action)} verification, but the SDK Agent is offline: ${reason}`)
      .replace(/^正在建立(.+)验证，DeRAS 将生成一次性挑战并等待机器人 SDK 签名。$/, (_, action) => `Creating ${known(action)} verification. DeRAS will wait for the robot SDK signature.`)
      .replace(/^挑战已生成，但机器人 SDK Agent 当前离线：(.+) 请在机器狗终端启动 Agent 后等待自动上报。$/, 'Challenge created, but the SDK Agent is offline: $1 Start the Agent on the robot and wait for its report.')
      .replace(/^机器人 SDK Agent 当前离线，无法申请结束服务。(.+)$/, 'The SDK Agent is offline, so service completion cannot be requested. $1')
      .replace(/^最近一次心跳是 (.+) 前。$/, 'Last heartbeat: $1 ago.')
      .replace(/^SDK版本 (.+)。$/, 'SDK version $1.')
      .replace(/^(.+)：请求超时，请检查后端服务和局域网连接。$/, '$1: Request timed out. Check the backend and local network.')
      .replace(/^(.+)：无法连接后端，请检查 8090 服务是否启动。$/, '$1: Cannot reach the backend. Check whether port 8090 is running.')
      .replace(/^当前阶段：(.+)。接单人取消会扣除10信誉分，任务会重新开放给其他服务者。请输入取消原因：$/, (_, stage) => `Current stage: ${known(stage)}. Provider cancellation deducts 10 reputation points and reopens the task. Enter a reason:`)
      .replace(/^当前阶段：(.+)。平台将按流程记录取消扣费 (.+) RoboCoin，剩余平台补助不再继续结算。请输入取消原因：$/, (_, stage, fee) => `Current stage: ${known(stage)}. A ${fee} RoboCoin cancellation fee will be recorded and the remaining subsidy will not settle. Enter a reason:`)
      .replace(/^任务已取消，平台补助扣费 (.+) RoboCoin，剩余 (.+) RoboCoin 不再结算$/, 'Task cancelled. Subsidy fee: $1 RoboCoin; remaining $2 RoboCoin will not settle.')
      .replace(/^服务机器人「(.+)」已接单，请等待出发。$/, 'Service robot "$1" accepted the task. Waiting for departure.')
      .replace(/^服务机器人「(.+)」已出发，正在前往接驳起点。$/, 'Service robot "$1" departed for the shuttle start point.')
      .replace(/^服务机器人「(.+)」已出发，正在前往服务点。$/, 'Service robot "$1" departed for the service point.')
      .replace(/^服务机器人「(.+)」已到达接驳起点，等待乘客确认\/服务者申请开始。$/, 'Service robot "$1" reached the shuttle start point. Waiting for boarding or start request.')
      .replace(/^服务机器人「(.+)」已到达，等待服务者申请开始。$/, 'Service robot "$1" arrived. Waiting for the provider to request start.')
      .replace(/^服务机器人「(.+)」正在前往接驳终点。$/, 'Service robot "$1" is heading to the shuttle destination.')
      .replace(/^服务机器人「(.+)」正在执行任务，等待服务者申请结束。$/, 'Service robot "$1" is working. Waiting for the provider to request completion.')
      .replace(/^服务机器人「(.+)」已完成任务。$/, 'Service robot "$1" completed the task.')
      .replace(/^最近一次 TPM 心跳是 (.+) 前，DeRAS 暂时不能确认机器人在线。$/, 'Last TPM heartbeat: $1 ago. DeRAS cannot currently confirm the robot is online.')
      .replace(/^最近一次车辆 GPS 是 (.+) 前，位置可能不是实时状态。$/, 'Last vehicle GPS update: $1 ago. The location may not be live.')
      .replace(/^(.+)前$/, '$1 ago')
      .replace(/^，SDK版本 (.+)$/, ', SDK version $1')
      .replace(/^最近一次 TPM 签名心跳 (.+)，当前机器人身份可被 DeRAS 追踪。$/, 'Latest TPM-signed heartbeat: $1. DeRAS can track the robot identity.')
      .replace(/^最近心跳：(.+)。出发、开始、结束节点仍以 TPM 验签作为可信门槛。$/, 'Latest heartbeat: $1. Departure, start, and completion still require TPM verification.')
      .replace(/^车辆当前目标是上车点：(.+)。$/, 'Current vehicle target is the pickup point: $1.')
      .replace(/^车辆已到达或正在等待从 (.+) 开始接驳。$/, 'The vehicle arrived or is waiting to start the shuttle from $1.')
      .replace(/^车辆当前目标是下车点：(.+)。$/, 'Current vehicle target is the drop-off point: $1.')
      .replace(/^接驳路线 (.+) → (.+) 已进入完成阶段。$/, 'Shuttle route $1 → $2 is in the completion stage.')
      .replace(/^起点：(.+)$/, 'Start: $1')
      .replace(/^终点：(.+) · (.+)$/, 'Destination: $1 · $2')
      .replace(/^坐标：(.+)$/, 'Coordinates: $1')
      .replace(/^取消阶段：(.+)，扣费 (.+)，退回 (.+)。$/, (_, stage, fee, refund) => `Cancellation stage: ${known(stage)}; fee ${fee}; refund ${refund}.`)
      .replace(/^平台补助：(.+) RoboCoin$/, 'Platform subsidy: $1 RoboCoin')
      .replace(/^最终应付 (.+)，退回 (.+)，补扣 (.+)。$/, 'Final amount $1; refund $2; additional charge $3.')
      .replace(/^当前阶段约扣 (.+)%$/, 'Approximate current deduction: $1%')
      .replace(/^机器人 (.+) 已接单，可以进入进行中任务追踪服务。$/, 'Robot $1 accepted the task. Open Active Tasks to track service.')
      .replace(/^DeRAS 已邀请 (.+)，正在等待服务者确认。$/, 'DeRAS invited $1 and is waiting for provider confirmation.')
      .replace(/^暂无(.+)消息$/, (_, type) => `No ${known(type)} Messages`)
      .replace(/^(.+)前心跳验签通过$/, 'Heartbeat signature verified $1 ago')
      .replace(/^(.+)前最后一次心跳$/, 'Last heartbeat $1 ago')
      .replace(/已连续 (\d+) 轮未找到可用候选/g, 'No candidate found in $1 consecutive rounds')
      .replace(/自动派单暂未找到候选/g, 'Auto-dispatch found no candidate')
      .replace(/任务已在任务市场开放兜底/g, 'The task is open for grabbing in the task market')
  }
  return value
    .replace(/^Step (\d+) of (\d+)$/i, '第 $1 / $2 步')
    .replace(/^Step (\d+)$/i, '第 $1 步')
    .replace(/^(\d+) robot types$/i, '$1 种机器人类型')
    .replace(/^(\d+) devices$/i, '$1 台设备')
    .replace(/^(\d+) tasks$/i, '$1 条任务')
    .replace(/^(\d+) unread messages$/, '还有 $1 条未读消息')
    .replace(/^(\d+) total$/, '共 $1 条')
    .replace(/DeRAS auto dispatch found no candidate; task opened for grabbing/gi, 'DeRAS 自动派单未找到候选，任务已开放抢单')
    .replace(/DeRAS recommendation: type matched; SDK online; robot idle; accepting orders; reputation passed;/gi, 'DeRAS 推荐：类型匹配、SDK 在线、机器人空闲、已开启接单且信誉校验通过；')
    .replace(/DeRAS scanned available robots\./gi, 'DeRAS 已扫描可用机器人。')
    .replace(/No candidate in dispatch scan/gi, '派单扫描未找到候选')
    .replace(/No available robot found\./gi, '未找到可用机器人。')
    .replace(/Auto dispatch reached (\d+) rounds without a candidate\./gi, '自动派单连续 $1 轮未找到候选。')
    .replace(/Task stays ACTIVE and visible in the task market\./gi, '任务保持可接单并展示在任务市场。')
    .replace(/Dispatch needs operational attention/gi, '派单需要人工关注')
    .replace(/Open for grabbing/gi, '开放抢单')
}

export function translate(value, targetLocale = localeState.locale) {
  if (typeof value !== 'string' || !value.trim()) return value
  const leading = value.match(/^\s*/)[0]
  const trailing = value.match(/\s*$/)[0]
  const core = value.trim()
  const dictionary = targetLocale === 'en' ? translations : reverseTranslations
  return `${leading}${dictionary[core] || translateDynamic(core, targetLocale)}${trailing}`
}

function translateElement(root = document.body) {
  if (!root) return
  const elements = root.nodeType === Node.ELEMENT_NODE ? [root, ...root.querySelectorAll('*')] : []
  elements.forEach(element => {
    if (['SCRIPT', 'STYLE', 'TEXTAREA'].includes(element.tagName)) return
    Array.from(element.childNodes)
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .forEach(node => {
        const next = translate(node.nodeValue)
        if (next !== node.nodeValue) node.nodeValue = next
      })
    ;['placeholder', 'title', 'aria-label'].forEach(attribute => {
      if (!element.hasAttribute(attribute)) return
      const current = element.getAttribute(attribute)
      const next = translate(current)
      if (next !== current) element.setAttribute(attribute, next)
    })
  })
}

let observer

export function applyLanguage() {
  document.documentElement.lang = 'en'
  translateElement(document.body)
}

export function setLocale() {
  applyLanguage()
}

export function installI18n(app) {
  app.config.globalProperties.$t = value => translate(value)
  observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'characterData') {
        const next = translate(record.target.nodeValue)
        if (next !== record.target.nodeValue) record.target.nodeValue = next
      } else {
        record.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) translateElement(node)
          if (node.nodeType === Node.TEXT_NODE) {
            const next = translate(node.nodeValue)
            if (next !== node.nodeValue) node.nodeValue = next
          }
        })
      }
    })
  })
  observer.observe(document.body, { childList: true, subtree: true, characterData: true })
  requestAnimationFrame(applyLanguage)
}
